import Vue from "vue";
import VueRouter from "vue-router";
import store from "../store";
Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: () => import("../views/home.vue"),
    meta: {
      title: "迪凡ERP", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },

  // 登录
  {
    path: "/login",
    name: "login",
    component: () => import("../views/login.vue"),
    meta: {
      title: "迪凡ERP登录", // 标题
      isLogin: false, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },

  // 首页信息
  {
    path: "/index",
    name: "index",
    component: () => import("../views/index.vue"),
    meta: {
      title: "首页", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  // 首页--下级页面信息
  {
    path: "/homePage",
    name: "homePage",
    component: () => import("../views/home/homePage.vue"),
    meta: {
      title: "下级页面", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/departmentList",
    name: "departmentList",
    component: () =>
      import("../views/organizationalStructure/departmentList.vue"),
    meta: {
      title: "部门列表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },

  {
    path: "/userList",
    name: "userList",
    component: () => import("../views/organizationalStructure/userList.vue"),
    meta: {
      title: "人员列表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/operAuth",
    name: "operAuth",
    component: () => import("../views/organizationalStructure/operAuth.vue"),
    meta: {
      title: "人员权限", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/userAttList",
    name: "userAttList",
    component: () => import("../views/organizationalStructure/userAttList.vue"),
    meta: {
      title: "人员信息维护", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/organizationalList",
    name: "organizationalList",
    component: () =>
      import("../views/organizationalStructure/organizationalList.vue"),
    meta: {
      title: "组织列表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },

  {
    path: "/userGroup",
    name: "userGroup",
    component: () => import("../views/organizationalStructure/userGroup.vue"),
    meta: {
      title: "人员分组", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/terUserList",
    name: "terUserList",
    component: () => import("../views/organizationalStructure/terUserList.vue"),
    meta: {
      title: "终端人员账号管理", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/safetyManage",
    name: "safetyManage",
    component: () => import("../views/modular.vue"),
    meta: {
      title: "安全管理", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },

  {
    path: "/financeUnit",
    name: "financeUnit",
    component: () => import("../views/modular.vue"),
    meta: {
      title: "财务单元", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },

  {
    path: "/organizationalStructure",
    name: "organizationalStructure",
    component: () => import("../views/modular.vue"),
    meta: {
      title: "组织架构", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },

  {
    path: "/organizationGroup",
    name: "organizationGroup",
    component: () =>
      import("../views/organizationalStructure/organizationGroup.vue"),
    meta: {
      title: "组织分组", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },

  {
    path: "/jurisdictionList",
    name: "jurisdictionList",
    component: () => import("../views/safetyManage/jurisdictionList.vue"),
    meta: {
      title: "权限列表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },

  {
    path: "/jurisdictionTemplate",
    name: "jurisdictionTemplate",
    component: () => import("../views/safetyManage/jurisdictionTemplate.vue"),
    meta: {
      title: "权限模板", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },

  {
    path: "/queryPrintRecordList",
    name: "queryPrintRecordList",
    component: () =>
      import("../views/safetyManage/recordMonitoring/queryPrintRecordList.vue"),
    meta: {
      title: "打印记录", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },

  {
    path: "/queryExportRecordList",
    name: "queryExportRecordList",
    component: () =>
      import(
        "../views/safetyManage/recordMonitoring/queryExportRecordList.vue"
      ),
    meta: {
      title: "打印记录", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/queryBackupList",
    name: "queryBackupList",
    component: () =>
      import("../views/safetyManage/dataBackup/queryBackupList.vue"),
    meta: {
      title: "备份列表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },

  {
    path: "/optionSettings",
    name: "optionSettings",
    component: () => import("../views/modular.vue"),
    meta: {
      title: "选项配置", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/dictionariesList",
    name: "dictionariesList",
    component: () => import("../views/optionSettings/dictionariesList.vue"),
    meta: {
      title: "字典列表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/codSettingList",
    name: "codSettingList",
    component: () => import("../views/optionSettings/codSettingList.vue"),
    meta: {
      title: "编号规则列表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },

  {
    path: "/boundaryWarningSettings",
    name: "boundaryWarningSettings",
    component: () =>
      import("../views/optionSettings/boundaryWarningSettings.vue"),
    meta: {
      title: "边界预警设置", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },

  {
    path: "/scopeManagement",
    name: "scopeManagement",
    component: () => import("../views/optionSettings/scopeManagement.vue"),
    meta: {
      title: "范围管理列表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/operationQuery",
    name: "operationQuery",
    component: () => import("../views/optionSettings/operationQuery.vue"),
    meta: {
      title: "手术类型管理", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/channelList",
    name: "channelList",
    component: () => import("../views/optionSettings/channelList.vue"),
    meta: {
      title: "渠道列表管理", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/licenseWarnDataList",
    name: "licenseWarnDataList",
    component: () => import("../views/optionSettings/licenseWarnDataList.vue"),
    meta: {
      title: "阈值配置列表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/makeInvoiceQuery",
    name: "makeInvoiceQuery",
    component: () => import("../views/optionSettings/makeInvoiceQuery.vue"),
    meta: {
      title: "阈值配置列表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/invoiceInfo",
    name: "invoiceInfo",
    component: () => import("../views/optionSettings/invoiceInfo.vue"),
    meta: {
      title: "开票信息", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/productionData",
    name: "productionData",
    component: () => import("../views/modular.vue"),
    meta: {
      title: "生产资料", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/wtsList",
    name: "wtsList",
    component: () => import("../views/wts/wtsList.vue"),
    meta: {
      title: "委托书列表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/wtsTask",
    name: "wtsTask",
    component: () => import("../views/wts/wtsTask.vue"),
    meta: {
      title: "委托书审核", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/wtsHistory",
    name: "wtsHistory",
    component: () => import("../views/wts/wtsHistory.vue"),
    meta: {
      title: "委托书打印", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/rawProducts",
    name: "rawProducts",
    component: () => import("../views/productionData/rawProducts.vue"),
    meta: {
      title: "表单列表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/officeSupplies",
    name: "officeSupplies",
    component: () => import("../views/productionData/officeSupplies.vue"),
    meta: {
      title: "办公用品", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },

  {
    path: "/businessGoods",
    name: "businessGoods",
    component: () => import("../views/productionData/businessGoods.vue"),
    meta: {
      title: "业务商品数据", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/basicsgoodList",
    name: "basicsgoodList",
    component: () => import("../views/productionData/basicsgoodList.vue"),
    meta: {
      title: "资料库商品管理", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/surgicalKit",
    name: "surgicalKit",
    component: () => import("../views/productionData/surgicalKit.vue"),
    meta: {
      title: "手术包档案管理", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/businessPriceMaintain",
    name: "businessPriceMaintain",
    component: () =>
      import("../views/productionData/businessPriceMaintain.vue"),
    meta: {
      title: "价格维护", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/businessPricechangeRecord",
    name: "businessPricechangeRecord",
    component: () =>
      import("../views/productionData/businessPricechangeRecord.vue"),
    meta: {
      title: "价格变更记录", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/batchPriceChangeList",
    name: "batchPriceChangeList",
    component: () => import("../views/productionData/batchPriceChangeList.vue"),
    meta: {
      title: "价格变更记录", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/hospitalBgmCode",
    name: "hospitalBgmCode",
    component: () => import("../views/productionData/hospitalBgmCode.vue"),
    meta: {
      title: "库房内部编码维护", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/goodsAttributesChange",
    name: "goodsAttributesChange",
    component: () =>
      import("../views/productionData/goodsAttributesChange.vue"),
    meta: {
      title: "业务属性调整", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/lowestPriceAudit",
    name: "lowestPriceAudit",
    component: () => import("../views/productionData/lowestPriceAudit.vue"),
    meta: {
      title: "最低售价审核", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/equipmentList",
    name: "equipmentList",
    component: () => import("../views/productionData/equipmentList.vue"),
    meta: {
      title: "设备设施列表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },

  {
    path: "/otherData",
    name: "otherData",
    component: () => import("../views/modular.vue"),
    meta: {
      title: "其它资料", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },

  {
    path: "/carList",
    name: "carList",
    component: () => import("../views/otherData/carList.vue"),
    meta: {
      title: "车辆列表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },

  {
    path: "/storageRoomList",
    name: "storageRoomList",
    component: () => import("../views/otherData/storageRoomList.vue"),
    meta: {
      title: "库房列表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },

  {
    path: "/cargoOwnerList",
    name: "cargoOwnerList",
    component: () => import("../views/otherData/cargoOwnerList.vue"),
    meta: {
      title: "货主列表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/cargoOwnerMfe",
    name: "cargoOwnerMfe",
    component: () => import("../views/otherData/cargoOwnerMfe.vue"),
    meta: {
      title: "货主商品管理费", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/coLevel",
    name: "coLevel",
    component: () => import("../views/otherData/coLevel.vue"),
    meta: {
      title: "货主级别维护", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },

  {
    path: "/formList",
    name: "formList",
    component: () => import("../views/safetyManage/formList.vue"),
    meta: {
      title: "表单列表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },

  {
    path: "/stockUnit",
    name: "stockUnit",
    component: () => import("../views/modular.vue"),
    meta: {
      title: "库存单元", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },

  // 业务商品期初录入
  {
    path: "/businessGoodsEntry",
    name: "businessGoodsEntry",
    component: () => import("../views/stockUnit/businessGoodsEntry.vue"),
    meta: {
      title: "库存单元", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },

  {
    path: "/unitData",
    name: "unitData",
    component: () => import("../views/modular.vue"),
    meta: {
      title: "单位资料", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },

  {
    path: "/unitCreditList",
    name: "unitCreditList",
    component: () =>
      import("../views/unitData/unitCreditManagement/unitCreditList.vue"),
    meta: {
      title: "单位授信列表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/unitCreditTask",
    name: "unitCreditTask",
    component: () =>
      import("../views/unitData/unitCreditManagement/unitCreditTask.vue"),
    meta: {
      title: "单位授信审核", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/unitCreditHis",
    name: "unitCreditHis",
    component: () =>
      import("../views/unitData/unitCreditManagement/unitCreditHis.vue"),
    meta: {
      title: "单位授信历史", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },

  {
    path: "/supplier",
    name: "supplier",
    component: () => import("../views/unitData/supplier.vue"),
    meta: {
      title: "供应商列表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/supplierDeposit",
    name: "supplierDeposit",
    component: () => import("../views/unitData/supplierDeposit.vue"),
    meta: {
      title: "供应商押金管理", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/supplierBank",
    name: "supplierBank",
    component: () => import("../views/unitData/supplierBank.vue"),
    meta: {
      title: "供货商银行维护", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/customerDeposit",
    name: "customerDeposit",
    component: () => import("../views/unitData/customerDeposit.vue"),
    meta: {
      title: "客户押金管理", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/cusplierBank",
    name: "cusplierBank",
    component: () => import("../views/unitData/cusplierBank.vue"),
    meta: {
      title: "客户银行维护", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/coBank",
    name: "coBank",
    component: () => import("../views/unitData/coBank.vue"),
    meta: {
      title: "货主银行维护", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },

  {
    path: "/supAddress",
    name: "supAddress",
    component: () => import("../views/unitData/supAddress.vue"),
    meta: {
      title: "供应商地址维护", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },

  {
    path: "/cusAddress",
    name: "cusAddress",
    component: () => import("../views/unitData/cusAddress.vue"),
    meta: {
      title: "客户地址维护", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/cusAuthAlarm",
    name: "cusAuthAlarm",
    component: () => import("../views/unitData/cusAuthAlarm.vue"),
    meta: {
      title: "客户授权预警", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/customerList",
    name: "customerList",
    component: () => import("../views/unitData/customerList.vue"),
    meta: {
      title: "客户列表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/cusAuthList",
    name: "cusAuthList",
    component: () => import("../views/unitData/cusAuthList.vue"),
    meta: {
      title: "客户资料授权", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/thirdPartyUnit",
    name: "thirdPartyUnit",
    component: () => import("../views/unitData/thirdPartyUnit.vue"),
    meta: {
      title: "三方单位管理", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },

  {
    path: "/thirdBank",
    name: "thirdBank",
    component: () => import("../views/unitData/thirdBank.vue"),
    meta: {
      title: "三方银行管理", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/terminalAdmin",
    name: "terminalAdmin",
    component: () => import("../views/unitData/terminalAdmin.vue"),
    meta: {
      title: "终端公司管理", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/terminalLineAdmin",
    name: "terminalLineAdmin",
    component: () => import("../views/unitData/terminalLineAdmin.vue"),
    meta: {
      title: "终端线路管理", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/terminalLine",
    name: "terminalLine",
    component: () => import("../views/unitData/terminalLine.vue"),
    meta: {
      title: "终端线路维护", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/terminalCompanyprice",
    name: "terminalCompanyprice",
    component: () => import("../views/unitData/terminalCompanyprice.vue"),
    meta: {
      title: "终端公司价格维护", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/purchasing",
    name: "purchasing",
    component: () => import("../views/modular.vue"),
    meta: {
      title: "采购单元", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },

  {
    path: "/procurementContract",
    name: "procurementContract",
    component: () => import("../views/purchasing/procurementContract.vue"),
    meta: {
      title: "采购合同列表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/procurementContractAudit",
    name: "procurementContractAudit",
    component: () => import("../views/purchasing/procurementContractAudit.vue"),
    meta: {
      title: "采购合同审核", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/puContractDetail",
    name: "puContractDetail",
    component: () => import("../views/purchasing/puContractDetail.vue"),
    meta: {
      title: "采购合同明细", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/procurementContractDetail",
    name: "procurementContractDetail",
    component: () =>
      import("../views/purchasing/procurementContractDetail.vue"),
    meta: {
      title: "采购合同明细", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/puContRebateList",
    name: "puContRebateList",
    component: () =>
      import("../views/purchasing/rebateUnit/puContRebateList.vue"),
    meta: {
      title: "采购返利列表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/puContRebateAudit",
    name: "puContRebateAudit",
    component: () =>
      import("../views/purchasing/rebateUnit/puContRebateAudit.vue"),
    meta: {
      title: "采购返利审核", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/puContRebateHis",
    name: "puContRebateHis",
    component: () =>
      import("../views/purchasing/rebateUnit/puContRebateHis.vue"),
    meta: {
      title: "采购返利历史", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },

  {
    path: "/purchaseOrderList",
    name: "purchaseOrderList",
    component: () =>
      import("../views/purchasing/purchaseOrder/purchaseOrderList.vue"),
    meta: {
      title: "采购订单列表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/purchaseScanqrOrderList",
    name: "purchaseScanqrOrderList",
    component: () =>
      import("../views/purchasing/purchaseOrder/purchaseScanqrOrderList.vue"),
    meta: {
      title: "采购订单(扫码)", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: '/purchaseQuality',
    name: 'purchaseQuality',
    component: () =>
      import('../views/purchasing/purchaseOrder/purchaseQuality.vue'),
    meta: {
      title: '验收质量复查', // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/puOnStorage",
    name: "puOnStorage",
    component: () =>
      import("../views/purchasing/purchaseOrder/puOnStorage.vue"),
    meta: {
      title: "采购入库", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/allotinList",
    name: "allotinList",
    component: () =>
      import("../views/purchasing/purchaseOrder/allotinList.vue"),
    meta: {
      title: "调拨入库", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/allotinTask",
    name: "allotinTask",
    component: () =>
      import("../views/purchasing/purchaseOrder/allotinTask.vue"),
    meta: {
      title: "调拨入库审核", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/allotinHis",
    name: "allotinHis",
    component: () => import("../views/purchasing/purchaseOrder/allotinHis.vue"),
    meta: {
      title: "调拨入库历史", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/puInstrumentOrderList",
    name: "puInstrumentOrderList",
    component: () =>
      import("../views/purchasing/purchaseOrder/puInstrumentOrderList.vue"),
    meta: {
      title: "采购订单(器械)", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },

  {
    path: "/purchaseOrderHistory",
    name: "purchaseOrderHistory",
    component: () =>
      import("../views/purchasing/purchaseOrder/purchaseOrderHistory.vue"),
    meta: {
      title: "采购订单历史", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },

  {
    path: "/inboundAccountingList",
    name: "inboundAccountingList",
    component: () =>
      import("../views/purchasing/purchaseOrder/inboundAccountingList.vue"),
    meta: {
      title: "入库记账列表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/openInventory",
    name: "openInventory",
    component: () =>
      import("../views/purchasing/purchaseOrder/openInventory.vue"),
    meta: {
      title: "期初入库记录", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/purchaseOrderTask",
    name: "purchaseOrderTask",
    component: () =>
      import("../views/purchasing/purchaseOrder/purchaseOrderTask.vue"),
    meta: {
      title: "采购订单审核", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/puUpList",
    name: "puUpList",
    component: () => import("../views/purchasing/purchaseOrder/puUpList.vue"),
    meta: {
      title: "采购上架列表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/purchasePriceVerification",
    name: "purchasePriceVerification",
    component: () => import("../views/purchasing/purchaseOrder/purchasePriceVerification.vue"),
    meta: {
      title: "采购入库核价", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/puBatchPrint",
    name: "puBatchPrint",
    component: () =>
      import("../views/purchasing/purchaseOrder/puBatchPrint.vue"),
    meta: {
      title: "采购入库批量打印", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/costAdTask",
    name: "costAdTask",
    component: () => import("../views/stockUnit/costAdjustment/costAdTask.vue"),
    meta: {
      title: "成本调整审核", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },

  {
    path: "/costAdList",
    name: "costAdList",
    component: () => import("../views/stockUnit/costAdjustment/costAdList.vue"),
    meta: {
      title: "成本调整列表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },

  {
    path: "/costAdHistory",
    name: "costAdHistory",
    component: () =>
      import("../views/stockUnit/costAdjustment/costAdHistory.vue"),
    meta: {
      title: "成本调整历史", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },

  {
    path: "/purchasePlan",
    name: "purchasePlan",
    component: () => import("../views/purchasing/purchasePlan.vue"),
    meta: {
      title: "缺货记录", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/goodInprice",
    name: "goodInprice",
    component: () => import("../views/purchasing/goodInprice.vue"),
    meta: {
      title: "询价列表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/goodInpriceAudit",
    name: "goodInpriceAudit",
    component: () => import("../views/purchasing/goodInpriceAudit.vue"),
    meta: {
      title: "询价审核", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/puPlanList",
    name: "puPlanList",
    component: () => import("../views/purchasing/puPlanList.vue"),
    meta: {
      title: "采购计划列表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },

  {
    path: "/pudePlanList",
    name: "pudePlanList",
    component: () => import("../views/purchasing/pudePlanList.vue"),
    meta: {
      title: "采购计划明细列表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },

  {
    path: "/purchaseReturnList",
    name: "purchaseReturnList",
    component: () =>
      import("../views/purchasing/purchaseReturn/purchaseReturnList.vue"),
    meta: {
      title: "采购退货列表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/stockpurchaseReturn",
    name: "stockpurchaseReturn",
    component: () =>
      import("../views/purchasing/purchaseReturn/stockpurchaseReturn.vue"),
    meta: {
      title: "库存采购退货", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/purchaseReturnNoticesList",
    name: "purchaseReturnNoticesList",
    component: () =>
      import(
        "../views/purchasing/purchaseReturn/purchaseReturnNoticesList.vue"
      ),
    meta: {
      title: "采购退货通知单", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/purchaseReturnNoticesTask",
    name: "purchaseReturnNoticesTask",
    component: () =>
      import(
        "../views/purchasing/purchaseReturn/purchaseReturnNoticesTask.vue"
      ),
    meta: {
      title: "采购退货通知单审核", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/purchaseReturnNoticesHistory",
    name: "purchaseReturnNoticesHistory",
    component: () =>
      import(
        "../views/purchasing/purchaseReturn/purchaseReturnNoticesHistory.vue"
      ),
    meta: {
      title: "采购退货通知单历史", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/purchaseReturnRed",
    name: "purchaseReturnRed",
    component: () =>
      import(
        "../views/purchasing/purchaseReturn/purchaseReturnRed.vue"
      ),
    meta: {
      title: "采购退货红冲列表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/purchaseRetrunRedTask",
    name: "purchaseRetrunRedTask",
    component: () =>
      import(
        "../views/purchasing/purchaseReturn/purchaseRetrunRedTask.vue"
      ),
    meta: {
      title: "采购退货红冲审核", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/purchaseRetrunRedHis",
    name: "purchaseRetrunRedHis",
    component: () =>
      import(
        "../views/purchasing/purchaseReturn/purchaseRetrunRedHis.vue"
      ),
    meta: {
      title: "采购退货红冲历史", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/purchaseRetrunRedAccount",
    name: "purchaseRetrunRedAccount",
    component: () =>
      import(
        "../views/purchasing/purchaseReturn/purchaseRetrunRedAccount.vue"
      ),
    meta: {
      title: "采购退货红冲记账列表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/puRetrunRedAccount",
    name: "puRetrunRedAccount",
    component: () =>
      import(
        "../views/purchasing/purchaseReturn/puRetrunRedAccount.vue"
      ),
    meta: {
      title: "采购退货红冲记账列表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/forecastCostList",
    name: "forecastCostList",
    component: () =>
      import("../views/purchasing/purchaseReturn/forecastCostList.vue"),
    meta: {
      title: "预估成本列表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },

  {
    path: "/purchaseReturnTask",
    name: "purchaseReturnTask",
    component: () =>
      import("../views/purchasing/purchaseReturn/purchaseReturnTask.vue"),
    meta: {
      title: "采购退货审核", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/purInitialReturnList",
    name: "purInitialReturnList",
    component: () =>
      import("../views/purchasing/purchaseReturn/purInitialReturnList.vue"),
    meta: {
      title: "期初采退列表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },

  {
    path: "/purchaseReturnHistory",
    name: "purchaseReturnHistory",
    component: () =>
      import("../views/purchasing/purchaseReturn/purchaseReturnHistory.vue"),
    meta: {
      title: "采购退货历史", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },

  {
    path: "/purchaseReturnReviewList",
    name: "purchaseReturnReviewList",
    component: () =>
      import("../views/purchasing/purchaseReturn/purchaseReturnReviewList.vue"),
    meta: {
      title: "采购退货复核", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/purchaseReturnAccount",
    name: "purchaseReturnAccount",
    component: () =>
      import("../views/purchasing/purchaseReturn/purchaseReturnAccount.vue"),
    meta: {
      title: "采购退货记账", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },

  {
    path: "/purchaseReceivingList",
    name: "purchaseReceivingList",
    component: () =>
      import("../views/purchasing/purchaseReceiving/purchaseReceivingList.vue"),
    meta: {
      title: "采购收货列表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },

  {
    path: "/purchaseReceivingTask",
    name: "purchaseReceivingTask",
    component: () =>
      import("../views/purchasing/purchaseReceiving/purchaseReceivingTask.vue"),
    meta: {
      title: "采购收货审核", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },

  {
    path: "/purchaseReceivingHistory",
    name: "purchaseReceivingHistory",
    component: () =>
      import(
        "../views/purchasing/purchaseReceiving/purchaseReceivingHistory.vue"
      ),
    meta: {
      title: "采购收货历史", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },

  {
    path: "/purchaseCheckList",
    name: "purchaseCheckList",
    component: () =>
      import("../views/purchasing/purchaseCheck/purchaseCheckList.vue"),
    meta: {
      title: "采购验收列表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },

  {
    path: "/purchaseCheckTask",
    name: "purchaseCheckTask",
    component: () =>
      import("../views/purchasing/purchaseCheck/purchaseCheckTask.vue"),
    meta: {
      title: "采购验收审核", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },

  {
    path: "/purchaseCheckHistory",
    name: "purchaseCheckHistory",
    component: () =>
      import("../views/purchasing/purchaseCheck/purchaseCheckHistory.vue"),
    meta: {
      title: "采购验收历史", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/purchaseSplitList",
    name: "purchaseSplitList",
    component: () =>
      import("../views/purchasing/purchaseSplitList/purchaseSplitList.vue"),
    meta: {
      title: "采购拆分验收", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/purchaQualityRecord",
    name: "purchaQualityRecord",
    component: () =>
      import("../views/purchasing/purchaQualityRecord/purchaQualityRecord.vue"),
    meta: {
      title: "验收复查记录", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/purchaseRefundList",
    name: "purchaseRefundList",
    component: () =>
      import("../views/purchasing/purchaseRefund/purchaseRefundList.vue"),
    meta: {
      title: "采购库存退补列表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/purStockchaseRefundList",
    name: "purStockchaseRefundList",
    component: () =>
      import("../views/purchasing/purchaseRefund/purStockchaseRefundList.vue"),
    meta: {
      title: "采购退补列表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/purInitiaRefundList",
    name: "purInitiaRefundList",
    component: () =>
      import("../views/purchasing/purchaseRefund/purInitiaRefundList.vue"),
    meta: {
      title: "期初退补列表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },

  {
    path: "/purchaseRefundTask",
    name: "purchaseRefundTask",
    component: () =>
      import("../views/purchasing/purchaseRefund/purchaseRefundTask.vue"),
    meta: {
      title: "采购退补审核", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },

  {
    path: "/purchaseRefundHistory",
    name: "purchaseRefundHistory",
    component: () =>
      import("../views/purchasing/purchaseRefund/purchaseRefundHistory.vue"),
    meta: {
      title: "采购退补历史", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/psRefundList",
    name: "psRefundList",
    component: () =>
      import("../views/purchasing/purchaseRefund/psRefundList.vue"),
    meta: {
      title: "采购退补记账", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/psAccountList",
    name: "psAccountList",
    component: () =>
      import("../views/purchasing/purchaseAccount/psAccountList.vue"),
    meta: {
      title: "采购入库记账", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/purchaseFileManagement",
    name: "purchaseFileManagement",
    component: () =>
      import("../views/purchasing/purchaseFile/purchaseFileManagement.vue"),
    meta: {
      title: "文件管理", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/salesFileManagement",
    name: "salesFileManagement",
    component: () =>
      import("../views/salesUnit/salesFile/salesFileManagement.vue"),
    meta: {
      title: "文件管理", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/psSettlementApply",
    name: "psSettlementApply",
    component: () =>
      import("../views/purchasing/purchaseSettlement/psSettlementApply.vue"),
    meta: {
      title: "采购结算申请", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/psSettlementHistory",
    name: "psSettlementHistory",
    component: () =>
      import("../views/purchasing/purchaseSettlement/psSettlementHistory.vue"),
    meta: {
      title: "采购结算历史", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/psSettlementTask",
    name: "psSettlementTask",
    component: () =>
      import("../views/purchasing/purchaseSettlement/psSettlementTask.vue"),
    meta: {
      title: "采购结算审核", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/psSettlementKeep",
    name: "psSettlementKeep",
    component: () =>
      import("../views/purchasing/purchaseSettlement/psSettlementKeep.vue"),
    meta: {
      title: "采购结算记账", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/purchasePaymentApply",
    name: "purchasePaymentApply",
    component: () =>
      import("../views/purchasing/purchasePayment/purchasePaymentApply.vue"),
    meta: {
      title: "付款申请", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/smFeeregistInit",
    name: "smFeeregistInit",
    component: () =>
      import("../views/purchasing/purchasePayment/smFeeregist/smFeeregistInit.vue"),
    meta: {
      title: "供应商费用登记列表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/smFeeregistAudit",
    name: "smFeeregistAudit",
    component: () =>
      import("../views/purchasing/purchasePayment/smFeeregist/smFeeregistAudit.vue"),
    meta: {
      title: "供应商费用登记审核", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/smFeeregistHis",
    name: "smFeeregistHis",
    component: () =>
      import("../views/purchasing/purchasePayment/smFeeregist/smFeeregistHis.vue"),
    meta: {
      title: "供应商费用登记历史", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/receOffsetPay",
    name: "receOffsetPay",
    component: () =>
      import("../views/purchasing/purchasePayment/receOffsetPay.vue"),
    meta: {
      title: "收付冲抵", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/psprepaySettle",
    name: "psprepaySettle",
    component: () =>
      import("../views/purchasing/purchasePayment/psprepaySettle.vue"),
    meta: {
      title: "预付款结算", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/psconprepaySettle",
    name: "psconprepaySettle",
    component: () =>
      import("../views/purchasing/purchasePayment/psconprepaySettle.vue"),
    meta: {
      title: "对账单付款结算", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/purchasePaymentApplyTask",
    name: "purchasePaymentApplyTask",
    component: () =>
      import(
        "../views/purchasing/purchasePayment/purchasePaymentApplyTask.vue"
      ),
    meta: {
      title: "付款审核", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/purchasePaymentApplyHis",
    name: "purchasePaymentApplyHis",
    component: () =>
      import("../views/purchasing/purchasePayment/purchasePaymentApplyHis.vue"),
    meta: {
      title: "付款历史", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },

  {
    path: "/advancePaymentReg",
    name: "advancePaymentReg",
    component: () =>
      import("../views/purchasing/purchasePayment/advancePaymentReg.vue"),
    meta: {
      title: "记账历史", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/advancePaymentAccount",
    name: "advancePaymentAccount",
    component: () =>
      import("../views/purchasing/purchasePayment/advancePaymentAccount.vue"),
    meta: {
      title: "付款记账", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: '/pssettleReport',
    name: 'pssettleReport',
    component: () =>
      import('../views/purchasing/purchasePayment/pssettleReport.vue'),
    meta: {
      title: '付款结算查询', // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/salesUnit",
    name: "salesUnit",
    component: () => import("../views/modular.vue"),
    meta: {
      title: "销售单元", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/salesPriceStrategy",
    name: "salesPriceStrategy",
    component: () =>
      import("../views/salesUnit/salesPrice/salesPriceStrategy.vue"),
    meta: {
      title: "价格策略级别", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },

  {
    path: "/salesInstrumentOrderList",
    name: "salesInstrumentOrderList",
    component: () =>
      import("../views/salesUnit/salesOrder/salesInstrumentOrderList.vue"),
    meta: {
      title: "销售订单(器械)", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },

  {
    path: "/salesOrderList",
    name: "salesOrderList",
    component: () => import("../views/salesUnit/salesOrder/salesOrderList.vue"),
    meta: {
      title: "销售订单列表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/cusPlanList",
    name: "cusPlanList",
    component: () => import("../views/salesUnit/salesOrder/cusPlanList.vue"),
    meta: {
      title: "客户销售目标", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/surgeOrderList",
    name: "surgeOrderList",
    component: () => import("../views/salesUnit/salesOrder/surgeOrderList.vue"),
    meta: {
      title: "手术订单", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/surgeOrderHis",
    name: "surgeOrderHis",
    component: () => import("../views/salesUnit/salesOrder/surgeOrderHis.vue"),
    meta: {
      title: "手术订单追踪", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/beforehandStockOut",
    name: "beforehandStockOut",
    component: () => import("../views/salesUnit/salesOrder/beforehandStockOut.vue"),
    meta: {
      title: "预出库订单列表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/pwoapplyAudit",
    name: "pwoapplyAudit",
    component: () => import("../views/salesUnit/salesOrder/pwoapplyAudit.vue"),
    meta: {
      title: "预出库订单审核", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/pwoapplyHis",
    name: "pwoapplyHis",
    component: () => import("../views/salesUnit/salesOrder/pwoapplyHis.vue"),
    meta: {
      title: "预出库订单历史", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/confirmDelive",
    name: "confirmDelive",
    component: () => import("../views/salesUnit/salesOrder/confirmDelive.vue"),
    meta: {
      title: "收货确认", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/flowRegit",
    name: "flowRegit",
    component: () => import("../views/salesUnit/salesOrder/flowRegit.vue"),
    meta: {
      title: "跟台登记", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/consumeList",
    name: "consumeList",
    component: () => import("../views/salesUnit/salesOrder/consumeList.vue"),
    meta: {
      title: "消耗单列表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/consumeAudit",
    name: "consumeAudit",
    component: () => import("../views/salesUnit/salesOrder/consumeAudit.vue"),
    meta: {
      title: "消耗单审核", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/backHis",
    name: "backHis",
    component: () => import("../views/salesUnit/salesOrder/backHis.vue"),
    meta: {
      title: "回库历史", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/dataflowTask",
    name: "dataflowTask",
    component: () => import("../views/salesUnit/salesOrder/dataflowTask.vue"),
    meta: {
      title: "数据流任务", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/consumeHis",
    name: "consumeHis",
    component: () => import("../views/salesUnit/salesOrder/consumeHis.vue"),
    meta: {
      title: "消耗单历史", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/surgeryReport",
    name: "surgeryReport",
    component: () => import("../views/salesUnit/salesOrder/surgeryReport.vue"),
    meta: {
      title: "手术日报报表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/voluntarilyPrint",
    name: "voluntarilyPrint",
    component: () => import("../views/salesUnit/salesOrder/voluntarilyPrint.vue"),
    meta: {
      title: "自动打印", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/pwoappHisReport",
    name: "pwoappHisReport",
    component: () => import("../views/salesUnit/salesOrder/pwoappHisReport.vue"),
    meta: {
      title: "预出库单历史报表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/termailRgisterReport",
    name: "termailRgisterReport",
    component: () => import("../views/salesUnit/salesOrder/termailRgisterReport.vue"),
    meta: {
      title: "终端登记信息查询", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/allotList",
    name: "allotList",
    component: () => import("../views/salesUnit/salesOrder/allotList.vue"),
    meta: {
      title: "调拨出库", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/allotListHistory",
    name: "allotListHistory",
    component: () =>
      import("../views/salesUnit/salesOrder/allotListHistory.vue"),
    meta: {
      title: "调拨出库历史", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/allotTask",
    name: "allotTask",
    component: () => import("../views/salesUnit/salesOrder/allotTask.vue"),
    meta: {
      title: "调拨出库审核", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/salesMergeOrderList",
    name: "salesMergeOrderList",
    component: () =>
      import("../views/salesUnit/salesOrder/salesMergeOrderList.vue"),
    meta: {
      title: "合并订单列表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/salesMergeQxOrderList",
    name: "salesMergeQxOrderList",
    component: () =>
      import("../views/salesUnit/salesOrder/salesMergeQxOrderList.vue"),
    meta: {
      title: "合并订单器械", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/woapplyBatchPrint",
    name: "woapplyBatchPrint",
    component: () =>
      import("../views/salesUnit/salesOrder/woapplyBatchPrint.vue"),
    meta: {
      title: "订单批量打印", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/wobkBatchPrint",
    name: "wobkBatchPrint",
    component: () =>
      import("../views/salesUnit/salesOrder/wobkBatchPrint.vue"),
    meta: {
      title: "出库订单批量打印", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/salesOrderMerge",
    name: "salesOrderMerge",
    component: () =>
      import("../views/salesUnit/salesOrder/salesOrderMerge.vue"),
    meta: {
      title: "销售订单合并", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/salesOrderTask",
    name: "salesOrderTask",
    component: () => import("../views/salesUnit/salesOrder/salesOrderTask.vue"),
    meta: {
      title: "销售订单审核", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },

  {
    path: "/salesOrderHistory",
    name: "salesOrderHistory",
    component: () =>
      import("../views/salesUnit/salesOrder/salesOrderHistory.vue"),
    meta: {
      title: "销售订单历史", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/salesReview",
    name: "salesReview",
    component: () => import("../views/salesUnit/salesOrder/salesReview.vue"),
    meta: {
      title: "销售出库复核", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/salesBatchReview",
    name: "salesBatchReview",
    component: () => import("../views/salesUnit/salesOrder/salesBatchReview.vue"),
    meta: {
      title: "销售出库复核", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/suContractList",
    name: "suContractList",
    component: () =>
      import("../views/salesUnit/salesContract/suContractList.vue"),
    meta: {
      title: "销售合同列表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/suContractSignInAudit",
    name: "suContractSignInAudit",
    component: () =>
      import("../views/salesUnit/salesContract/suContractSignInAudit.vue"),
    meta: {
      title: "销售合同审核", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/suContractSignIn",
    name: "suContractSignIn",
    component: () =>
      import("../views/salesUnit/salesContract/suContractSignIn.vue"),
    meta: {
      title: "销售合同登记", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/suContractDetail",
    name: "suContractDetail",
    component: () =>
      import("../views/salesUnit/salesContract/suContractDetail.vue"),
    meta: {
      title: "销售合同明细", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/bookkeepingOrderList",
    name: "bookkeepingOrderList",
    component: () =>
      import("../views/salesUnit/salesOrder/bookkeepingOrderList.vue"),
    meta: {
      title: "销售出库记账", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/openInventoryOut",
    name: "openInventoryOut",
    component: () =>
      import("../views/salesUnit/salesOrder/openInventoryOut.vue"),
    meta: {
      title: "期初出库记录", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/woapplyFileList",
    name: "woapplyFileList",
    component: () =>
      import("../views/salesUnit/salesOrder/woapplyFileList.vue"),
    meta: {
      title: "出库文件管理", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/financialCollect",
    name: "financialCollect",
    component: () =>
      import("../views/salesUnit/salesOrder/financialCollect.vue"),
    meta: {
      title: "财务收款", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/salesOneList",
    name: "salesOneList",
    component: () => import("../views/salesUnit/salesOrder/salesOneList.vue"),
    meta: {
      title: "销售出库", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/xsorderPoolList",
    name: "xsorderPoolList",
    component: () =>
      import("../views/salesUnit/salesOrder/xsorderPoolList.vue"),
    meta: {
      title: "外部订单列表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/wdtOrderList",
    name: "wdtOrderList",
    component: () =>
      import("../views/salesUnit/salesOrder/wdtOrderList.vue"),
    meta: {
      title: "旺店通订单", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/retailWebPoolList",
    name: "retailWebPoolList",
    component: () =>
      import("../views/salesUnit/salesOrder/retailWebPoolList.vue"),
    meta: {
      title: "线上零售订单", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/retailWebO2OPoolList",
    name: "retailWebO2OPoolList",
    component: () =>
      import("../views/salesUnit/salesOrder/retailWebO2OPoolList.vue"),
    meta: {
      title: "线上零售O2O订单", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/retailWebOrderList",
    name: "retailWebOrderList",
    component: () =>
      import("../views/salesUnit/salesOrder/retailWebOrderList.vue"),
    meta: {
      title: "线上零售记录", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/retailWebRejUndoList",
    name: "retailWebRejUndoList",
    component: () =>
      import("../views/salesUnit/salesOrder/retailWebRejUndoList.vue"),
    meta: {
      title: "退货未操作报表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/xsMxdetailCancleList",
    name: "xsMxdetailCancleList",
    component: () =>
      import("../views/salesUnit/salesOrder/xsMxdetailCancleList.vue"),
    meta: {
      title: "明细取消确认", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/xsbadnessReportList",
    name: "xsbadnessReportList",
    component: () =>
      import("../views/salesUnit/salesOrder/xsbadnessReportList.vue"),
    meta: {
      title: "不良事件报告", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/specialPriceApplyList",
    name: "specialPriceApplyList",
    component: () =>
      import("../views/salesUnit/specialPriceApply/specialPriceApplyList.vue"),
    meta: {
      title: "特价申请列表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },

  {
    path: "/specialPriceApplyTask",
    name: "specialPriceApplyTask",
    component: () =>
      import("../views/salesUnit/specialPriceApply/specialPriceApplyTask.vue"),
    meta: {
      title: "特价申请审核", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/activityManagement",
    name: "activityManagement",
    component: () =>
      import("../views/salesUnit/specialPriceApply/activityManagement.vue"),
    meta: {
      title: "活动管理", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/specialPriceApplyHistory",
    name: "specialPriceApplyHistory",
    component: () =>
      import(
        "../views/salesUnit/specialPriceApply/specialPriceApplyHistory.vue"
      ),
    meta: {
      title: "特价申请历史", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },

  {
    path: "/shortageRegistration",
    name: "shortageRegistration",
    component: () => import("../views/salesUnit/shortageRegistration.vue"),
    meta: {
      title: "缺货登记列表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },

  {
    path: "/promotionStrategy",
    name: "promotionStrategy",
    component: () => import("../views/salesUnit/promotionStrategy.vue"),
    meta: {
      title: "促销策略", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/limitCustomers",
    name: "limitCustomers",
    component: () => import("../views/salesUnit/limitCustomers.vue"),
    meta: {
      title: "控销商品列表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },

  {
    path: "/controlruleDataList",
    name: "controlruleDataList",
    component: () => import("../views/salesUnit/controlruleDataList.vue"),
    meta: {
      title: "控销策略", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/controlGoodsList",
    name: "controlGoodsList",
    component: () => import("../views/salesUnit/controlGoodsList.vue"),
    meta: {
      title: "商品控销", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/limitSales",
    name: "limitSales",
    component: () => import("../views/salesUnit/limitSales.vue"),
    meta: {
      title: "控销业务员", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/limitSalesGoods",
    name: "limitSalesGoods",
    component: () => import("../views/salesUnit/limitSalesGoods.vue"),
    meta: {
      title: "业务员控销品种", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/prepairControlList",
    name: "prepairControlList",
    component: () => import("../views/salesUnit/prepairControlList.vue"),
    meta: {
      title: "复方制剂控销", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/controlGoodsDetailList",
    name: "controlGoodsDetailList",
    component: () => import("../views/salesUnit/controlGoodsDetailList.vue"),
    meta: {
      title: "商品控销明细", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/salesReturnTZList",
    name: "salesReturnTZList",
    component: () =>
      import("../views/salesUnit/salesReturn/salesReturnTZList.vue"),
    meta: {
      title: "销售退货通知单", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/salesReturnTZTask",
    name: "salesReturnTZTask",
    component: () =>
      import("../views/salesUnit/salesReturn/salesReturnTZTask.vue"),
    meta: {
      title: "销售退货通知单审核", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/salesReturnTZHistory",
    name: "salesReturnTZHistory",
    component: () =>
      import("../views/salesUnit/salesReturn/salesReturnTZHistory.vue"),
    meta: {
      title: "销售退货通知单历史", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/salesReturnList",
    name: "salesReturnList",
    component: () =>
      import("../views/salesUnit/salesReturn/salesReturnList.vue"),
    meta: {
      title: "退货申请列表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/oneStepsalesInitiaReturnList",
    name: "oneStepsalesInitiaReturnList",
    component: () =>
      import("../views/salesUnit/salesReturn/oneStepsalesInitiaReturnList.vue"),
    meta: {
      title: "销退记账列表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/salesInitiaReturnList",
    name: "salesInitiaReturnList",
    component: () =>
      import("../views/salesUnit/salesReturn/salesInitiaReturnList.vue"),
    meta: {
      title: "期初销退列表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/salesReturnTask",
    name: "salesReturnTask",
    component: () =>
      import("../views/salesUnit/salesReturn/salesReturnTask.vue"),
    meta: {
      title: "退货申请审核", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },

  {
    path: "/salesReturnHistory",
    name: "salesReturnHistory",
    component: () =>
      import("../views/salesUnit/salesReturn/salesReturnHistory.vue"),
    meta: {
      title: "退货申请历史", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },

  {
    path: "/salesReturnCheckList",
    name: "salesReturnCheckList",
    component: () =>
      import("../views/salesUnit/salesReturn/salesReturnCheckList.vue"),
    meta: {
      title: "销售退货验收列表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/salesUpList",
    name: "salesUpList",
    component: () => import("../views/salesUnit/salesReturn/salesUpList.vue"),
    meta: {
      title: "退货上架列表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  // {
  // 	path: '/salesReturnCheckTask',
  // 	name: 'salesReturnCheckTask',
  // 	component: () => import('../views/salesUnit/salesReturn/salesReturnCheckTask.vue'),
  // 	meta: {
  // 		title: '销售退货验收任务',  // 标题
  // 		isLogin: true,  // 是否要登录
  // 		webType: 2,  // 页面归类,1一级页面，2二级页面
  // 	},
  // },

  {
    path: "/salesReturnCheckHistory",
    name: "salesReturnCheckHistory",
    component: () =>
      import("../views/salesUnit/salesReturn/salesReturnCheckHistory.vue"),
    meta: {
      title: "销售退货验收历史", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },

  {
    path: "/salesReturnAccount",
    name: "salesReturnAccount",
    component: () =>
      import("../views/salesUnit/salesReturn/salesReturnAccount.vue"),
    meta: {
      title: "销售退货记账", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },

  {
    path: "/salesReceivingList",
    name: "salesReceivingList",
    component: () =>
      import("../views/salesUnit/salesReturn/salesReceivingList.vue"),
    meta: {
      title: "退货收货列表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },

  // {
  // 	path: '/salesReceivingTask',
  // 	name: 'salesReceivingTask',
  // 	component: () => import('../views/salesUnit/salesReturn/salesReceivingTask.vue'),
  // 	meta: {
  // 		title: '销售退货收货审核',  // 标题
  // 		isLogin: true,  // 是否要登录
  // 		webType: 2,  // 页面归类,1一级页面，2二级页面
  // 	},
  // },

  {
    path: "/salesReceivingHistory",
    name: "salesReceivingHistory",
    component: () =>
      import("../views/salesUnit/salesReturn/salesReceivingHistory.vue"),
    meta: {
      title: "销售退货收货历史", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/desuLimitClassify",
    name: "desuLimitClassify",
    component: () =>
      import("../views/salesUnit/desuLimit/desuLimitClassify.vue"),
    meta: {
      title: "限销分类", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/desuLimitDetail",
    name: "desuLimitDetail",
    component: () => import("../views/salesUnit/desuLimit/desuLimitDetail.vue"),
    meta: {
      title: "限销商品", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/desuLimitGoodClassify",
    name: "desuLimitGoodClassify",
    component: () =>
      import("../views/salesUnit/desuLimit/desuLimitGoodClassify.vue"),
    meta: {
      title: "限销商品分类", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/limitApplication",
    name: "limitApplication",
    component: () =>
      import("../views/salesUnit/limitApplication/limitApplication.vue"),
    meta: {
      title: "限销商品超量申请列表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/limitCheck",
    name: "limitCheck",
    component: () =>
      import("../views/salesUnit/limitApplication/limitCheck.vue"),
    meta: {
      title: "限销商品超量审核", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/limitHistory",
    name: "limitHistory",
    component: () =>
      import("../views/salesUnit/limitApplication/limitHistory.vue"),
    meta: {
      title: "限销商品超量历史", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/multipleimitDetail",
    name: "multipleimitDetail",
    component: () =>
      import("../views/salesUnit/desuLimit/multipleimitDetail.vue"),
    meta: {
      title: "限销倍数", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/restrictionStrategyList",
    name: "restrictionStrategyList",
    component: () =>
      import(
        "../views/salesUnit/restrictionStrategy/restrictionStrategyList.vue"
      ),
    meta: {
      title: "限销策略列表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },

  {
    path: '/restrictionStrategyGroup',
    name: 'restrictionStrategyGroup',
    component: () =>
      import('../views/salesUnit/restrictionStrategy/restrictionStrategyGroup.vue'),
    meta: {
      title: '限销策略分组', // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: '/suWoplanList',
    name: 'suWoplanList',
    component: () =>
      import('../views/salesUnit/market/suWoplanList.vue'),
    meta: {
      title: '销售计划列表', // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: '/suWoplanAudit',
    name: 'suWoplanAudit',
    component: () =>
      import('../views/salesUnit/market/suWoplanAudit.vue'),
    meta: {
      title: '销售计划审核', // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: '/suWoplanHis',
    name: 'suWoplanHis',
    component: () =>
      import('../views/salesUnit/market/suWoplanHis.vue'),
    meta: {
      title: '销售计划历史', // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: '/storageRoom',
    name: 'storageRoom',
    component: () =>
      import('../views/modular.vue'),
    meta: {
      title: '库房单元', // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },

  {
    path: "/loadingOrderRecord",
    name: "loadingOrderRecord",
    component: () =>
      import("../views/storageRoom/HandlingManagement/loadingOrderRecord.vue"),
    meta: {
      title: "装车单记录", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },

  {
    path: "/unloadingListRecord",
    name: "unloadingListRecord",
    component: () =>
      import("../views/storageRoom/HandlingManagement/unloadingListRecord.vue"),
    meta: {
      title: "卸车单登记", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },

  {
    path: "/logisticsOrderList",
    name: "logisticsOrderList",
    component: () =>
      import("../views/storageRoom/deliveryManagement/logisticsOrderList.vue"),
    meta: {
      title: "订单物流列表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },

  {
    path: "/logisticsList",
    name: "logisticsList",
    component: () => import("../views/storageRoom/logisticsList.vue"),
    meta: {
      title: "物流列表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },

  {
    path: "/deliveryPlan",
    name: "deliveryPlan",
    component: () => import("../views/storageRoom/deliveryPlan.vue"),
    meta: {
      title: "发货计划", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },

  {
    path: "/oilCardManagement",
    name: "oilCardManagement",
    component: () =>
      import("../views/storageRoom/refuelingCard/oilCardManagement.vue"),
    meta: {
      title: "油卡管理", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },

  {
    path: "/oilCardRechargeHis",
    name: "oilCardRechargeHis",
    component: () =>
      import("../views/storageRoom/refuelingCard/oilCardRechargeHis.vue"),
    meta: {
      title: "油卡充值记录", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },

  {
    path: "/oilCardRefuelingHis",
    name: "oilCardRefuelingHis",
    component: () =>
      import("../views/storageRoom/refuelingCard/oilCardRefuelingHis.vue"),
    meta: {
      title: "油卡加油记录", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },

  {
    path: "/receiptList",
    name: "receiptList",
    component: () =>
      import("../views/storageRoom/receiptManagement/receiptList.vue"),
    meta: {
      title: "回执管理列表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },

  {
    path: "/stockLossList",
    name: "stockLossList",
    component: () => import("../views/stockUnit/stockLoss/stockLossList.vue"),
    meta: {
      title: "库存报损列表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },

  {
    path: "/stockLossTask",
    name: "stockLossTask",
    component: () => import("../views/stockUnit/stockLoss/stockLossTask.vue"),
    meta: {
      title: "库存报损审核", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },

  {
    path: "/stockLossHistory",
    name: "stockLossHistory",
    component: () =>
      import("../views/stockUnit/stockLoss/stockLossHistory.vue"),
    meta: {
      title: "库存报损历史", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },

  {
    path: "/stockOverflowList",
    name: "stockOverflowList",
    component: () =>
      import("../views/stockUnit/stockOverflow/stockOverflowList.vue"),
    meta: {
      title: "库存报溢列表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },

  {
    path: "/stockOverflowTask",
    name: "stockOverflowTask",
    component: () =>
      import("../views/stockUnit/stockOverflow/stockOverflowTask.vue"),
    meta: {
      title: "库存报溢审核", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },

  {
    path: "/stockOverflowHistory",
    name: "stockOverflowHistory",
    component: () =>
      import("../views/stockUnit/stockOverflow/stockOverflowHistory.vue"),
    meta: {
      title: "库存报溢历史", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },

  {
    path: "/stockMoveList",
    name: "stockMoveList",
    component: () => import("../views/stockUnit/stockMove/stockMoveList.vue"),
    meta: {
      title: "库存移库列表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/stockMoveMasterHis",
    name: "stockMoveMasterHis",
    component: () => import("../views/stockUnit/stockMove/stockMoveMasterHis.vue"),
    meta: {
      title: "库存移库历史", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/stockMoveTask",
    name: "stockMoveTask",
    component: () => import("../views/stockUnit/stockMove/stockMoveTask.vue"),
    meta: {
      title: "库存移库审核", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },

  {
    path: "/stockMoveHistory",
    name: "stockMoveHistory",
    component: () =>
      import("../views/stockUnit/stockMove/stockMoveHistory.vue"),
    meta: {
      title: "库存移库历史", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/stockMoveOneStepList",
    name: "stockMoveOneStepList",
    component: () => import("../views/stockUnit/stockMove/stockMoveOneStepList.vue"),
    meta: {
      title: "库存移库一步", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/gspUnit",
    name: "gspUnit",
    component: () => import("../views/modular.vue"),
    meta: {
      title: "GSP单元", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },

  {
    path: "/authorityApplyList",
    name: "authorityApplyList",
    component: () =>
      import("../views/gspUnit/authorityApply/authorityApplyList.vue"),
    meta: {
      title: "权限申请列表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/authorityApplyTask",
    name: "authorityApplyTask",
    component: () =>
      import("../views/gspUnit/authorityApply/authorityApplyTask.vue"),
    meta: {
      title: "权限申请审核", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/authorityApplyHistory",
    name: "authorityApplyHistory",
    component: () =>
      import("../views/gspUnit/authorityApply/authorityApplyHistory.vue"),
    meta: {
      title: "权限申请历史", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },

  // {
  //   path: "/flowChartList",
  //   name: "flowChartList",
  //   component: () => import("../views/optionSettings/flowChartList.vue"),
  //   meta: {
  //     title: "流程列表", // 标题
  //     isLogin: true, // 是否要登录
  //     webType: 2, // 页面归类,1一级页面，2二级页面
  //   },
  // },

  // {
  //   path: "/flowChart",
  //   name: "flowChart",
  //   component: () => import("../views/optionSettings/flowChart.vue"),
  //   meta: {
  //     title: "流程图", // 标题
  //     isLogin: true, // 是否要登录
  //     webType: 2, // 页面归类,1一级页面，2二级页面
  //   },
  // },

  {
    path: "/unqualifiedRegisterList",
    name: "unqualifiedRegisterList",
    component: () =>
      import(
        "../views/gspUnit/unqualifiedRegister/unqualifiedRegisterList.vue"
      ),
    meta: {
      title: "登记列表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },

  {
    path: "/unqualifiedRegisterTask",
    name: "unqualifiedRegisterTask",
    component: () =>
      import(
        "../views/gspUnit/unqualifiedRegister/unqualifiedRegisterTask.vue"
      ),
    meta: {
      title: "登记审核", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },

  {
    path: "/unqualifiedRegisterHistory",
    name: "unqualifiedRegisterHistory",
    component: () =>
      import(
        "../views/gspUnit/unqualifiedRegister/unqualifiedRegisterHistory.vue"
      ),
    meta: {
      title: "登记历史", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },

  {
    path: "/unqualifiedDamageList",
    name: "unqualifiedDamageList",
    component: () =>
      import("../views/gspUnit/unqualifiedDamage/unqualifiedDamageList.vue"),
    meta: {
      title: "报损列表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },

  {
    path: "/unqualifiedDamageTask",
    name: "unqualifiedDamageTask",
    component: () =>
      import("../views/gspUnit/unqualifiedDamage/unqualifiedDamageTask.vue"),
    meta: {
      title: "报损审核", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },

  {
    path: "/unqualifiedDamageHistory",
    name: "unqualifiedDamageHistory",
    component: () =>
      import("../views/gspUnit/unqualifiedDamage/unqualifiedDamageHistory.vue"),
    meta: {
      title: "报损历史", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },

  {
    path: "/unqualifiedDestruction",
    name: "unqualifiedDestruction",
    component: () => import("../views/gspUnit/unqualifiedDestruction.vue"),
    meta: {
      title: "销毁列表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },

  {
    path: "/unqualifiedDestructionReview",
    name: "unqualifiedDestructionReview",
    component: () =>
      import("../views/gspUnit/unqualifiedDestructionReview.vue"),
    meta: {
      title: "销毁审核", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },

  {
    path: "/unqualifiedDestructionHistory",
    name: "unqualifiedDestructionHistory",
    component: () =>
      import("../views/gspUnit/unqualifiedDestructionHistory.vue"),
    meta: {
      title: "销毁历史", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/unqualifiedDestructionRecord",
    name: "unqualifiedDestructionRecord",
    component: () =>
      import("../views/gspUnit/unqualifiedDestructionRecord.vue"),
    meta: {
      title: "不合格报损记录", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/firstGoodsList",
    name: "firstGoodsList",
    component: () => import("../views/gspUnit/firstGoods/firstGoodsList.vue"),
    meta: {
      title: "首营商品列表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },

  {
    path: "/firstGoodsTask",
    name: "firstGoodsTask",
    component: () => import("../views/gspUnit/firstGoods/firstGoodsTask.vue"),
    meta: {
      title: "首营商品审核", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },

  {
    path: "/firstGoodsHistory",
    name: "firstGoodsHistory",
    component: () =>
      import("../views/gspUnit/firstGoods/firstGoodsHistory.vue"),
    meta: {
      title: "首营商品历史", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/goodLicenceTask",
    name: "goodLicenceTask",
    component: () => import("../views/gspUnit/firstGoods/goodLicenceTask.vue"),
    meta: {
      title: "商品证照记录审核", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/goodLicenceHistory",
    name: "goodLicenceHistory",
    component: () =>
      import("../views/gspUnit/firstGoods/goodLicenceHistory.vue"),
    meta: {
      title: "商品证照记录历史", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/firstSupplierList",
    name: "firstSupplierList",
    component: () =>
      import("../views/gspUnit/firstSupplier/firstSupplierList.vue"),
    meta: {
      title: "供应商列表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/firstSupplierTask",
    name: "firstSupplierTask",
    component: () =>
      import("../views/gspUnit/firstSupplier/firstSupplierTask.vue"),
    meta: {
      title: "供应商审核", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/firstSupplierHistory",
    name: "firstSupplierHistory",
    component: () =>
      import("../views/gspUnit/firstSupplier/firstSupplierHistory.vue"),
    meta: {
      title: "供应商历史", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/suplicencelinfonoteTask",
    name: "suplicencelinfonoteTask",
    component: () =>
      import("../views/gspUnit/firstSupplier/suplicencelinfonoteTask.vue"),
    meta: {
      title: "供应商证照记录审核", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/suplicencelinfonoteHistory",
    name: "suplicencelinfonoteHistory",
    component: () =>
      import("../views/gspUnit/firstSupplier/suplicencelinfonoteHistory.vue"),
    meta: {
      title: "供应商证照记录历史", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/firstCustomerList",
    name: "firstCustomerList",
    component: () =>
      import("../views/gspUnit/firstCustomer/firstCustomerList.vue"),
    meta: {
      title: "首营客户列表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/firstCustomerTask",
    name: "firstCustomerTask",
    component: () =>
      import("../views/gspUnit/firstCustomer/firstCustomerTask.vue"),
    meta: {
      title: "首营客户审核", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/firstCustomerHistory",
    name: "firstCustomerHistory",
    component: () =>
      import("../views/gspUnit/firstCustomer/firstCustomerHistory.vue"),
    meta: {
      title: "首营客户历史", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/cuslicencelinfonoteTask",
    name: "cuslicencelinfonoteTask",
    component: () =>
      import("../views/gspUnit/firstCustomer/cuslicencelinfonoteTask.vue"),
    meta: {
      title: "首营客户审核", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/cuslicencelinfonoteHistory",
    name: "cuslicencelinfonoteHistory",
    component: () =>
      import("../views/gspUnit/firstCustomer/cuslicencelinfonoteHistory.vue"),
    meta: {
      title: "首营客户历史", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/maintenancePlan",
    name: "maintenancePlan",
    component: () => import("../views/gspUnit/maintenancePlan.vue"),
    meta: {
      title: "养护计划列表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/maintenanceregister",
    name: "maintenanceregister",
    component: () => import("../views/gspUnit/maintenanceregister.vue"),
    meta: {
      title: "养护计划登记", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/recallNoticeList",
    name: "recallNoticeList",
    component: () =>
      import("../views/gspUnit/recallNotice/recallNoticeList.vue"),
    meta: {
      title: "通知单列表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },

  {
    path: "/recallNoticeTask",
    name: "recallNoticeTask",
    component: () =>
      import("../views/gspUnit/recallNotice/recallNoticeTask.vue"),
    meta: {
      title: "通知单审核", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },

  {
    path: "/recallNoticeHistory",
    name: "recallNoticeHistory",
    component: () =>
      import("../views/gspUnit/recallNotice/recallNoticeHistory.vue"),
    meta: {
      title: "通知单历史", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },

  {
    path: "/recallRegistrationList",
    name: "recallRegistrationList",
    component: () =>
      import("../views/gspUnit/recallNotice/recallRegistrationList.vue"),
    meta: {
      title: "召回登记", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },

  {
    path: "/stopSellingList",
    name: "stopSellingList",
    component: () => import("../views/gspUnit/stopSelling/stopSellingList.vue"),
    meta: {
      title: "停售登记", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/toolStopRegist",
    name: "toolStopRegist",
    component: () => import("../views/gspUnit/stopSelling/toolStopRegist.vue"),
    meta: {
      title: "工具停售", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/stopReviewList",
    name: "stopReviewList",
    component: () => import("../views/gspUnit/stopSelling/stopReviewList.vue"),
    meta: {
      title: "质量复查记录", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/auditReviewList",
    name: "auditReviewList",
    component: () => import("../views/gspUnit/stopSelling/auditReviewList.vue"),
    meta: {
      title: "质量复查审核", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/releaseList",
    name: "releaseList",
    component: () => import("../views/gspUnit/stopSelling/releaseList.vue"),
    meta: {
      title: "解除停售记录", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/maintenanceRulesList",
    name: "maintenanceRulesList",
    component: () =>
      import("../views/gspUnit/stopSelling/maintenanceRulesList.vue"),
    meta: {
      title: "养护规则登记", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/stopSellingTask",
    name: "stopSellingTask",
    component: () => import("../views/gspUnit/stopSelling/stopSellingTask.vue"),
    meta: {
      title: "停售审核任务", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },

  {
    path: "/stopSellingHistory",
    name: "stopSellingHistory",
    component: () =>
      import("../views/gspUnit/stopSelling/stopSellingHistory.vue"),
    meta: {
      title: "停售历史", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },

  {
    path: "/removeStopSellingList",
    name: "removeStopSellingList",
    component: () =>
      import("../views/gspUnit/removeStopSelling/removeStopSellingList.vue"),
    meta: {
      title: "解除停售列表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },

  {
    path: "/removeStopSellingTask",
    name: "removeStopSellingTask",
    component: () =>
      import("../views/gspUnit/removeStopSelling/removeStopSellingTask.vue"),
    meta: {
      title: "解除停售任务", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },

  {
    path: "/removeStopSellingHistory",
    name: "removeStopSellingHistory",
    component: () =>
      import("../views/gspUnit/removeStopSelling/removeStopSellingHistory.vue"),
    meta: {
      title: "解除停售历史", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },

  {
    path: "/dataChangeTask",
    name: "dataChangeTask",
    component: () => import("../views/gspUnit/dataChange/dataChangeTask.vue"),
    meta: {
      title: "资料变更审核", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },

  {
    path: "/dataChangeHistory",
    name: "dataChangeHistory",
    component: () =>
      import("../views/gspUnit/dataChange/dataChangeHistory.vue"),
    meta: {
      title: "资料变更历史", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/changeData",
    name: "changeData",
    component: () => import("../views/gspUnit/dataChange/changeData.vue"),
    meta: {
      title: "资料变更新", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },

  {
    path: "/attributeAdjustmentList",
    name: "attributeAdjustmentList",
    component: () =>
      import(
        "../views/stockUnit/attributeAdjustment/attributeAdjustmentList.vue"
      ),
    meta: {
      title: "库存属性列表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },

  {
    path: "/attributeAdjustmentTask",
    name: "attributeAdjustmentTask",
    component: () =>
      import(
        "../views/stockUnit/attributeAdjustment/attributeAdjustmentTask.vue"
      ),
    meta: {
      title: "库存属性审核", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },

  {
    path: "/attributeAdjustmentHistory",
    name: "attributeAdjustmentHistory",
    component: () =>
      import(
        "../views/stockUnit/attributeAdjustment/attributeAdjustmentHistory.vue"
      ),
    meta: {
      title: "库存属性历史", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/bgaChangeList",
    name: "bgaChangeList",
    component: () =>
      import(
        "../views/stockUnit/bgaChange/bgaChangeList.vue"
      ),
    meta: {
      title: "库存附加属性调整", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/bgaChangeTask",
    name: "bgaChangeTask",
    component: () =>
      import(
        "../views/stockUnit/bgaChange/bgaChangeTask.vue"
      ),
    meta: {
      title: "库存附加属性调整审核", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/bgaChangeHistory",
    name: "bgaChangeHistory",
    component: () =>
      import(
        "../views/stockUnit/bgaChange/bgaChangeHistory.vue"
      ),
    meta: {
      title: "库存附加属性调整历史", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/stockLnventoryPlan",
    name: "stockLnventoryPlan",
    component: () =>
      import("../views/stockUnit/stockLnventory/stockLnventoryPlan.vue"),
    meta: {
      title: "盘点计划列表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/stockDifference",
    name: "stockDifference",
    component: () =>
      import("../views/stockUnit/stockLnventory/stockDifference.vue"),
    meta: {
      title: "厂家库存对比", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/stockDifferenceAudit",
    name: "stockDifferenceAudit",
    component: () =>
      import("../views/stockUnit/stockLnventory/stockDifferenceAudit.vue"),
    meta: {
      title: "厂家库存对比审核", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/stockDifferenceHis",
    name: "stockDifferenceHis",
    component: () =>
      import("../views/stockUnit/stockLnventory/stockDifferenceHis.vue"),
    meta: {
      title: "厂家库存对比历史", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/stockLnventoryTask",
    name: "stockLnventoryTask",
    component: () =>
      import("../views/stockUnit/stockLnventory/stockLnventoryTask.vue"),
    meta: {
      title: "盘点核对审核", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },

  {
    path: "/stockLnventoryHistory",
    name: "stockLnventoryHistory",
    component: () =>
      import("../views/stockUnit/stockLnventory/stockLnventoryHistory.vue"),
    meta: {
      title: "盘点计划历史", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },

  {
    path: "/stockLnventoryReject",
    name: "stockLnventoryReject",
    component: () =>
      import("../views/stockUnit/stockLnventory/stockLnventoryReject.vue"),
    meta: {
      title: "盘点计划核对", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/stockLimitList",
    name: "stockLimitList",
    component: () => import("../views/stockUnit/stockLimit/stockLimitList.vue"),
    meta: {
      title: "上下限列表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/stockQueryList",
    name: "stockQueryList",
    component: () =>
      import("../views/stockUnit/iconsanfangkucunjilu/stockQueryList.vue"),
    meta: {
      title: "库存查询", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/stockTransferList",
    name: "stockTransferList",
    component: () =>
      import("../views/stockUnit/iconsanfangkucunjilu/stockTransferList.vue"),
    meta: {
      title: "库存转移", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/stockAdjustmentList",
    name: "stockAdjustmentList",
    component: () =>
      import("../views/stockUnit/iconsanfangkucunjilu/stockAdjustmentList.vue"),
    meta: {
      title: "库存调整", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },

  {
    path: "/salesReimbursementList",
    name: "salesReimbursementList",
    component: () =>
      import(
        "../views/salesUnit/salesReimbursement/salesReimbursementList.vue"
      ),
    meta: {
      title: "销售退补申请", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/rateSalesReimburList",
    name: "rateSalesReimburList",
    component: () =>
      import(
        "../views/salesUnit/salesReimbursement/rateSalesReimburList.vue"
      ),
    meta: {
      title: "比例销售退补", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/salesReimtheearlyList",
    name: "salesReimtheearlyList",
    component: () =>
      import("../views/salesUnit/salesReimbursement/salesReimtheearlyList.vue"),
    meta: {
      title: "期初退补申请", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },

  {
    path: "/salesReimburListPrint",
    name: "salesReimburListPrint",
    component: () =>
      import("../views/salesUnit/salesReimbursement/salesReimburListPrint.vue"),
    meta: {
      title: "销售退补批量打印", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },

  {
    path: "/salesReimbursementTask",
    name: "salesReimbursementTask",
    component: () =>
      import(
        "../views/salesUnit/salesReimbursement/salesReimbursementTask.vue"
      ),
    meta: {
      title: "销售退补审核", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },

  {
    path: "/salesReimbursementHistory",
    name: "salesReimbursementHistory",
    component: () =>
      import(
        "../views/salesUnit/salesReimbursement/salesReimbursementHistory.vue"
      ),
    meta: {
      title: "销售退补历史", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },

  {
    path: "/salesReimbursementAccount",
    name: "salesReimbursementAccount",
    component: () =>
      import(
        "../views/salesUnit/salesReimbursement/salesReimbursementAccount.vue"
      ),
    meta: {
      title: "销售退补记账", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/salesPrePayList",
    name: "salesPrePayList",
    component: () =>
      import("../views/salesUnit/salesPayment/salesPrePayList.vue"),
    meta: {
      title: "收款记账历史", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/salesPrePayApplyInitList",
    name: "salesPrePayApplyInitList",
    component: () =>
      import("../views/salesUnit/salesPayment/salesPrePayApplyInitList.vue"),
    meta: {
      title: "收款申请列表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/salesPrePayApplyAuditList",
    name: "salesPrePayApplyAuditList",
    component: () =>
      import("../views/salesUnit/salesPayment/salesPrePayApplyAuditList.vue"),
    meta: {
      title: "收款申请审核", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/salesPrePayAccount",
    name: "salesPrePayAccount",
    component: () =>
      import("../views/salesUnit/salesPayment/salesPrePayAccount.vue"),
    meta: {
      title: "收款记账列表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/salesPrePayApplyHistList",
    name: "salesPrePayApplyHistList",
    component: () =>
      import("../views/salesUnit/salesPayment/salesPrePayApplyHistList.vue"),
    meta: {
      title: "收款申请历史", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/salesSettleApply",
    name: "salesSettleApply",
    component: () =>
      import("../views/salesUnit/salesSettlement/salesSettleApply.vue"),
    meta: {
      title: "销售结算申请", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/salesSettleApplyHis",
    name: "salesSettleApplyHis",
    component: () =>
      import("../views/salesUnit/salesSettlement/salesSettleApplyHis.vue"),
    meta: {
      title: "结算申请历史", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/salesSettleAccount",
    name: "salesSettleAccount",
    component: () =>
      import("../views/salesUnit/salesSettlement/salesSettleAccount.vue"),
    meta: {
      title: "销售结算记账", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/salesSettleOrderbyAccount",
    name: "salesSettleOrderbyAccount",
    component: () =>
      import(
        "../views/salesUnit/salesSettlement/salesSettleOrderbyAccount.vue"
      ),
    meta: {
      title: "销售逐单结算", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/electronicBusinessAccount",
    name: "electronicBusinessAccount",
    component: () =>
      import(
        "../views/salesUnit/salesSettlement/electronicBusinessAccount.vue"
      ),
    meta: {
      title: "电商逐单结算", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/salesSettleKeep",
    name: "salesSettleKeep",
    component: () =>
      import("../views/salesUnit/salesSettlement/salesSettleKeep.vue"),
    meta: {
      title: "结算记账历史", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/receivedvanceSettle",
    name: "receivedvanceSettle",
    component: () =>
      import("../views/salesUnit/salesSettlement/receivedvanceSettle.vue"),
    meta: {
      title: "预收结算", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: '/salesSettleReport',
    name: 'salesSettleReport',
    component: () =>
      import('../views/salesUnit/salesSettlement/salesSettleReport.vue'),
    meta: {
      title: '收款结算查询', // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/salesFeeRegister",
    name: "salesFeeRegister",
    component: () =>
      import("../views/salesUnit/salesSettlement/salesFeeRegister/salesFeeRegister.vue"),
    meta: {
      title: "客户费用登记", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/salesFeeRegisterAudit",
    name: "salesFeeRegisterAudit",
    component: () =>
      import("../views/salesUnit/salesSettlement/salesFeeRegister/salesFeeRegisterAudit.vue"),
    meta: {
      title: "客户费用登记审核", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/salesFeeRegisterHis",
    name: "salesFeeRegisterHis",
    component: () =>
      import("../views/salesUnit/salesSettlement/salesFeeRegister/salesFeeRegisterHis.vue"),
    meta: {
      title: "客户费用登记历史", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/lackWarning",
    name: "lackWarning",
    component: () => import("../views/stockUnit/stockWarning/lackWarning.vue"),
    meta: {
      title: "缺货预警", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },

  {
    path: "/newTimeWaring",
    name: "newTimeWaring",
    component: () =>
      import("../views/stockUnit/stockWarning/newTimeWaring.vue"),
    meta: {
      title: "近效期预警", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },

  {
    path: "/unsalableWarning",
    name: "unsalableWarning",
    component: () =>
      import("../views/stockUnit/stockWarning/unsalableWarning.vue"),
    meta: {
      title: "滞销预警", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },

  {
    path: "/salesmanList",
    name: "salesmanList",
    component: () => import("../views/unitData/salesmanList.vue"),
    meta: {
      title: "单位委托书列表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/salesmasterList",
    name: "salesmasterList",
    component: () => import("../views/unitData/salesmasterList.vue"),
    meta: {
      title: "对方业务员列表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },

  {
    path: "/customerStrategyGroup",
    name: "customerStrategyGroup",
    component: () =>
      import("../views/salesUnit/customerStrategy/customerStrategyGroup.vue"),
    meta: {
      title: "客户策略分组", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },

  {
    path: "/strategyCustomerList",
    name: "strategyCustomerList",
    component: () =>
      import("../views/salesUnit/customerStrategy/strategyCustomerList.vue"),
    meta: {
      title: "策略客户列表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },

  {
    path: "/priceStrategyGroupList",
    name: "priceStrategyGroupList",
    component: () =>
      import("../views/salesUnit/priceStrategy/priceStrategyGroupList.vue"),
    meta: {
      title: "价格策略分组", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },

  {
    path: "/priceStrategyList",
    name: "priceStrategyList",
    component: () =>
      import("../views/salesUnit/priceStrategy/priceStrategyList.vue"),
    meta: {
      title: "价格策略列表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },

  {
    path: "/initBookkeeping",
    name: "initBookkeeping",
    component: () => import("../views/financeUnit/initBookkeeping.vue"),
    meta: {
      title: "期初记账", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/purchaseInvoiceList",
    name: "purchaseInvoiceList",
    component: () => import("../views/financeUnit/purchaseInvoiceList.vue"),
    meta: {
      title: "采购发票列表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/purchaseInvoiceTask",
    name: "purchaseInvoiceTask",
    component: () => import("../views/financeUnit/purchaseInvoiceTask.vue"),
    meta: {
      title: "采购发票审核", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/purchaseInvoiceHistory",
    name: "purchaseInvoiceHistory",
    component: () => import("../views/financeUnit/purchaseInvoiceHistory.vue"),
    meta: {
      title: "采购发票历史", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/purchaseInvoiceAuthentication",
    name: "purchaseInvoiceAuthentication",
    component: () =>
      import("../views/financeUnit/purchaseInvoiceAuthentication.vue"),
    meta: {
      title: "采购发票认证", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/queryPsDrawBillInit",
    name: "queryPsDrawBillInit",
    component: () =>
      import("../views/financeUnit/queryPsDrawBillInit.vue"),
    meta: {
      title: "采购开票申请列表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/queryPsDrawBillAudit",
    name: "queryPsDrawBillAudit",
    component: () =>
      import("../views/financeUnit/queryPsDrawBillAudit.vue"),
    meta: {
      title: "采购发票申请审核", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/queryPsDrawBillHis",
    name: "queryPsDrawBillHis",
    component: () =>
      import("../views/financeUnit/queryPsDrawBillHis.vue"),
    meta: {
      title: "采购发票申请历史", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/salesInvoiceList",
    name: "salesInvoiceList",
    component: () => import("../views/financeUnit/salesInvoiceList.vue"),
    meta: {
      title: "销售发票列表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/salesInvoiceTask",
    name: "salesInvoiceTask",
    component: () => import("../views/financeUnit/salesInvoiceTask.vue"),
    meta: {
      title: "销售发票审核", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/salesInvoiceHistory",
    name: "salesInvoiceHistory",
    component: () => import("../views/financeUnit/salesInvoiceHistory.vue"),
    meta: {
      title: "销售发票历史", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/queryDrawBillInit",
    name: "queryDrawBillInit",
    component: () => import("../views/financeUnit/queryDrawBillInit.vue"),
    meta: {
      title: "开票申请列表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/queryDrawBillAudit",
    name: "queryDrawBillAudit",
    component: () => import("../views/financeUnit/queryDrawBillAudit.vue"),
    meta: {
      title: "开票申请审核", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/queryDrawBillHis",
    name: "queryDrawBillHis",
    component: () => import("../views/financeUnit/queryDrawBillHis.vue"),
    meta: {
      title: "开票申请历史", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },

  // T+凭证
  {
    path: "/voucherManager",
    name: "voucherManager",
    component: () => import("../views/financeUnit/voucher/voucherManager.vue"),
    meta: {
      title: "凭证管理", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/voucherRecoverManager",
    name: "voucherRecoverManager",
    component: () =>
      import("../views/financeUnit/voucher/voucherRecoverManager.vue"),
    meta: {
      title: "恢复凭证管理", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  // 内账管理
  {
    path: "/internalAccountManger",
    name: "internalAccountManger",
    component: () =>
      import("../views/financeUnit/voucher/internalAccountManger.vue"),
    meta: {
      title: "内账管理", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },

  // 账簿管理
  {
    path: "/accountBooksManager",
    name: "accountBooksManager",
    component: () =>
      import("../views/financeUnit/accountBooks/accountBooksManager.vue"),
    meta: {
      title: "账簿管理", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },

  // 货主费用登记类目
  {
    path: "/costRegisterManger",
    name: "costRegisterManger",
    component: () => import("../views/financeUnit/costRegisterManger.vue"),
    meta: {
      title: "货主费用登记类目", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },

  // 货主费用管理
  {
    path: "/ownerExpensesRegister",
    name: "ownerExpensesRegister",
    component: () =>
      import("../views/financeUnit/ownerExpenses/ownerExpensesRegister.vue"),
    meta: {
      title: "货主费用登记", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/ownerTaskAudit",
    name: "ownerTaskAudit",
    component: () =>
      import("../views/financeUnit/ownerExpenses/ownerTaskAudit.vue"),
    meta: {
      title: "货主报销审核", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/ownerTaskHis",
    name: "ownerTaskHis",
    component: () =>
      import("../views/financeUnit/ownerExpenses/ownerTaskHis.vue"),
    meta: {
      title: "货主报销历史", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  // 货主账款调拨列表
  {
    path: "/ownermoneychangeList",
    name: "ownermoneychangeList",
    component: () =>
      import(
        "../views/financeUnit/ownerAccountTransfer/ownermoneychangeList.vue"
      ),
    meta: {
      title: "货主账款调拨列表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  // 货主账款调拨审核
  {
    path: "/ownermoneychangeAduit",
    name: "ownermoneychangeAduit",
    component: () =>
      import(
        "../views/financeUnit/ownerAccountTransfer/ownermoneychangeAduit.vue"
      ),
    meta: {
      title: "货主账款调拨审核", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  // 货主账款调拨历史
  {
    path: "/ownermoneychangeHis",
    name: "ownermoneychangeHis",
    component: () =>
      import(
        "../views/financeUnit/ownerAccountTransfer/ownermoneychangeHis.vue"
      ),
    meta: {
      title: "货主账款调拨历史", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },

  // 预收管理费
  {
    path: "/ownerManageSettle",
    name: "ownerManageSettle",
    component: () =>
      import("../views/financeUnit/ownerExpenses/ownerManageSettle.vue"),
    meta: {
      title: "预收管理费", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  // 货主提现审核
  {
    path: "/coWithdrawAudit",
    name: "coWithdrawAudit",
    component: () =>
      import("../views/financeUnit/ownerExpenses/coWithdrawAudit.vue"),
    meta: {
      title: "货主提现审核", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  // 货主提现列表
  {
    path: "/coWithdrawList",
    name: "coWithdrawList",
    component: () =>
      import("../views/financeUnit/ownerExpenses/coWithdrawList.vue"),
    meta: {
      title: "货主提现列表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  // 单位付款审核
  {
    path: "/unitPayAduit",
    name: "unitPayAduit",
    component: () =>
      import("../views/financeUnit/ownerExpenses/unitPayAduit.vue"),
    meta: {
      title: "单位付款审核", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },

  // 货主发票余额
  {
    path: "/queryAllCoInvoice",
    name: "queryAllCoInvoice",
    component: () =>
      import("../views/financeUnit/ownerExpenses/queryAllCoInvoice.vue"),
    meta: {
      title: "货主发票余额", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },

  // 财务报表
  {
    path: "/advancePaymentStatement",
    name: "advancePaymentStatement",
    component: () =>
      import("../views/financeUnit/statements/advancePaymentStatement.vue"),
    meta: {
      title: "预付款报表分析", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  // 财务报表
  {
    path: "/opmCurrentReport",
    name: "opmCurrentReport",
    component: () =>
      import("../views/financeUnit/statements/opmCurrentReport.vue"),
    meta: {
      title: "业务员往来账", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  // 财务报表
  {
    path: "/queryOpmPerfReportList",
    name: "queryOpmPerfReportList",
    component: () =>
      import("../views/financeUnit/statements/queryOpmPerfReportList.vue"),
    meta: {
      title: "业务员业绩分析", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  // 财务报表
  {
    path: '/unitReconionList',
    name: 'unitReconionList',
    component: () =>
      import('../views/financeUnit/statements/unitReconionList.vue'),
    meta: {
      title: '单位调账管理', // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  // 财务报表
  {
    path: "/queryCoPerfReportList",
    name: "queryCoPerfReportList",
    component: () =>
      import("../views/financeUnit/statements/queryCoPerfReportList.vue"),
    meta: {
      title: "货主业绩分析", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  // 财务报表
  {
    path: "/queryCmContrReportList",
    name: "queryCmContrReportList",
    component: () =>
      import("../views/financeUnit/statements/queryCmContrReportList.vue"),
    meta: {
      title: "货主业绩分析", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  // 财务报表
  {
    path: "/queryPayReportList",
    name: "queryPayReportList",
    component: () =>
      import("../views/financeUnit/statements/queryPayReportList.vue"),
    meta: {
      title: "付款查询", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  // 财务报表
  {
    path: "/querySalesArrearsReportList",
    name: "querySalesArrearsReportList",
    component: () =>
      import("../views/financeUnit/statements/querySalesArrearsReportList.vue"),
    meta: {
      title: "销售欠款分析", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  // 财务报表
  {
    path: "/querySalesRanReportList",
    name: "querySalesRanReportList",
    component: () =>
      import("../views/financeUnit/statements/querySalesRanReportList.vue"),
    meta: {
      title: "销售排行分析", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/cusQkReport",
    name: "cusQkReport",
    component: () => import("../views/financeUnit/statements/cusQkReport.vue"),
    meta: {
      title: "客户欠款明细", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/queryPuArrearsReportList",
    name: "queryPuArrearsReportList",
    component: () =>
      import("../views/financeUnit/statements/queryPuArrearsReportList.vue"),
    meta: {
      title: "采购欠款分析", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  // 财务报表
  {
    path: "/queryCoMoneyReport",
    name: "queryCoMoneyReport",
    component: () =>
      import("../views/financeUnit/statements/queryCoMoneyReport.vue"),
    meta: {
      title: "货主资金报表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  // 财务报表
  {
    path: "/queryCoMWLReport",
    name: "queryCoMWLReport",
    component: () =>
      import("../views/financeUnit/statements/queryCoMWLReport.vue"),
    meta: {
      title: "货主单位往来帐报表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  // 财务报表
  {
    path: "/queryCoCashFlow",
    name: "queryCoCashFlow",
    component: () =>
      import("../views/financeUnit/statements/queryCoCashFlow.vue"),
    meta: {
      title: "货主资金流水", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  // 财务报表 收款分析
  {
    path: "/queryReAnalyzeReportList",
    name: "queryReAnalyzeReportList",
    component: () =>
      import("../views/financeUnit/statements/queryReAnalyzeReportList.vue"),
    meta: {
      title: "收款分析", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  // 经营毛利分析 收款分析
  {
    path: "/queryOperProfitReportList",
    name: "queryOperProfitReportList",
    component: () =>
      import("../views/financeUnit/statements/queryOperProfitReportList.vue"),
    meta: {
      title: "收款分析", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  // 账簿资金流水报表
  {
    path: "/bookMoneyAnalyList",
    name: "bookMoneyAnalyList",
    component: () =>
      import("../views/financeUnit/statements/bookMoneyAnalyList.vue"),
    meta: {
      title: "账簿资金流水报表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  // 财务报表 销售结算查询
  {
    path: "/querySusettleReportList",
    name: "querySusettleReportList",
    component: () =>
      import("../views/financeUnit/statements/querySusettleReportList.vue"),
    meta: {
      title: "销售结算查询", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/advancePaymentStatementDetail",
    name: "advancePaymentStatementDetail",
    component: () =>
      import(
        "../views/financeUnit/statements/advancePaymentStatementDetail.vue"
      ),
    meta: {
      title: "预付款明细报表分析", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/advanceCollectionReport",
    name: "advanceCollectionReport",
    component: () =>
      import("../views/financeUnit/statements/advanceCollectionReport.vue"),
    meta: {
      title: "预收款报表分析", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/supFinanicalRecoList",
    name: "supFinanicalRecoList",
    component: () =>
      import("../views/financeUnit/statements/supFinanicalRecoList.vue"),
    meta: {
      title: "供应商对帐", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/cusfinanicalReconList",
    name: "cusfinanicalReconList",
    component: () =>
      import("../views/financeUnit/statements/cusfinanicalReconList.vue"),
    meta: {
      title: "客户财务对账", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/saleSettlementStatement",
    name: "saleSettlementStatement",
    component: () =>
      import("../views/financeUnit/statements/saleSettlementStatement.vue"),
    meta: {
      title: "销售结算报表分析", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/settlementStatement",
    name: "settlementStatement",
    component: () =>
      import("../views/financeUnit/statements/settlementStatement.vue"),
    meta: {
      title: "结算报表分析", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/vendorCurrentAccount",
    name: "vendorCurrentAccount",
    component: () =>
      import("../views/financeUnit/statements/vendorCurrentAccount.vue"),
    meta: {
      title: "供货商往来账", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/payMxReport",
    name: "payMxReport",
    component: () => import("../views/financeUnit/statements/payMxReport.vue"),
    meta: {
      title: "应付款明细报表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/receMxReport",
    name: "receMxReport",
    component: () => import("../views/financeUnit/statements/receMxReport.vue"),
    meta: {
      title: "应收款明细报表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/customerCurrentAccount",
    name: "customerCurrentAccount",
    component: () =>
      import("../views/financeUnit/statements/customerCurrentAccount.vue"),
    meta: {
      title: "客户往来账", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/oppositeBusinessRepresentativeCurrentAccount",
    name: "oppositeBusinessRepresentativeCurrentAccount",
    component: () =>
      import(
        "../views/financeUnit/statements/oppositeBusinessRepresentativeCurrentAccount.vue"
      ),
    meta: {
      title: "对方业务员往来账", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/ownerCurrentAccount",
    name: "ownerCurrentAccount",
    component: () =>
      import("../views/financeUnit/statements/ownerCurrentAccount.vue"),
    meta: {
      title: "货主往来账", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/businessManagerCurrentAccount",
    name: "businessManagerCurrentAccount",
    component: () =>
      import(
        "../views/financeUnit/statements/businessManagerCurrentAccount.vue"
      ),
    meta: {
      title: "业务员往来账", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/operatingCurrentAccount",
    name: "operatingCurrentAccount",
    component: () =>
      import("../views/financeUnit/statements/operatingCurrentAccount.vue"),
    meta: {
      title: "经营往来账", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/customerReceAccount",
    name: "customerReceAccount",
    component: () =>
      import("../views/financeUnit/statements/customerReceAccount.vue"),
    meta: {
      title: "客户应收款查询", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/supplierAgingAnalysis",
    name: "supplierAgingAnalysis",
    component: () =>
      import("../views/financeUnit/statements/supplierAgingAnalysis.vue"),
    meta: {
      title: "供应商账龄分析", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/customerAgingAnalysis",
    name: "customerAgingAnalysis",
    component: () =>
      import("../views/financeUnit/statements/customerAgingAnalysis.vue"),
    meta: {
      title: "客户账龄分析", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/customerOperatorAccounts",
    name: "customerOperatorAccounts",
    component: () =>
      import("../views/financeUnit/statements/customerOperatorAccounts.vue"),
    meta: {
      title: "客户业务员应收款分析", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/customerAccounts",
    name: "customerAccounts",
    component: () =>
      import("../views/financeUnit/statements/customerAccounts.vue"),
    meta: {
      title: "客户应收款分析", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/customerOperatorAccountInvoice",
    name: "customerOperatorAccountInvoice",
    component: () =>
      import("../views/financeUnit/statements/customerOperatorAccountInvoice.vue"),
    meta: {
      title: "客户业务员应收款分析(发票)", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/ownersReceivables",
    name: "ownersReceivables",
    component: () =>
      import("../views/financeUnit/statements/ownersReceivables.vue"),
    meta: {
      title: "货主应收款分析", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/accountReceivable",
    name: "accountReceivable",
    component: () =>
      import("../views/financeUnit/statements/accountReceivable.vue"),
    meta: {
      title: "业务员应收款分析", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/suplierCurrentReport",
    name: "suplierCurrentReport",
    component: () =>
      import("../views/financeUnit/statements/suplierCurrentReport.vue"),
    meta: {
      title: "供应商往来账", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/supPayAccount",
    name: "supPayAccount",
    component: () =>
      import("../views/financeUnit/statements/supPayAccount.vue"),
    meta: {
      title: "供应商应付款帐报表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/customerCurrentReport",
    name: "customerCurrentReport",
    component: () =>
      import("../views/financeUnit/statements/customerCurrentReport.vue"),
    meta: {
      title: "客户往来账", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/customerReceSummery",
    name: "customerReceSummery",
    component: () =>
      import("../views/financeUnit/statements/customerReceSummery.vue"),
    meta: {
      title: "客户应收汇总", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/bookRecardReportList",
    name: "bookRecardReportList",
    component: () =>
      import("../views/financeUnit/statements/bookRecardReportList.vue"),
    meta: {
      title: "账簿资金流水", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/bookMoneyReportList",
    name: "bookMoneyReportList",
    component: () =>
      import("../views/financeUnit/statements/bookMoneyReportList.vue"),
    meta: {
      title: "账簿资金报表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/suInvoicevoidBList",
    name: "suInvoicevoidBList",
    component: () =>
      import("../views/financeUnit/statements/suInvoicevoidBList.vue"),
    meta: {
      title: "销售发票作废记录", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/puInvoicevoidBList",
    name: "puInvoicevoidBList",
    component: () =>
      import("../views/financeUnit/statements/puInvoicevoidBList.vue"),
    meta: {
      title: "采购发票作废记录", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },

  {
    path: "/dataQuery",
    name: "dataQuery",
    component: () => import("../views/modular.vue"),
    meta: {
      title: "数据查询", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/stockQuery",
    name: "stockQuery",
    component: () => import("../views/dataQuery/queryStatics/stockQuery.vue"),
    meta: {
      title: "库存查询", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/queryOrderDetailList",
    name: "queryOrderDetailList",
    component: () =>
      import("../views/dataQuery/purchase/queryOrderDetailList.vue"),
    meta: {
      title: "采购订单明细", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/puDetailReportList",
    name: "puDetailReportList",
    component: () =>
      import("../views/dataQuery/purchase/puDetailReportList.vue"),
    meta: {
      title: "采购明细表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/puReportAnalyzeList",
    name: "puReportAnalyzeList",
    component: () =>
      import("../views/dataQuery/purchase/puReportAnalyzeList.vue"),
    meta: {
      title: "采购报表分析", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/puInstock",
    name: "puInstock",
    component: () => import("../views/dataQuery/purchase/puInstock.vue"),
    meta: {
      title: "采购入库明细报表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/queryRestockList",
    name: "queryRestockList",
    component: () => import("../views/dataQuery/purchase/queryRestockList.vue"),
    meta: {
      title: "采购报表分析", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/puSummary",
    name: "puSummary",
    component: () => import("../views/dataQuery/purchase/puSummary.vue"),
    meta: {
      title: "采购汇总查询", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/puDetail",
    name: "puDetail",
    component: () => import("../views/dataQuery/purchase/puDetail.vue"),
    meta: {
      title: "采购明细查询", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/queryReconciliationList",
    name: "queryReconciliationList",
    component: () =>
      import("../views/dataQuery/purchase/queryReconciliationList.vue"),
    meta: {
      title: "每日对账表	", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/suDetailReportList",
    name: "suDetailReportList",
    component: () =>
      import("../views/dataQuery/purchase/suDetailReportList.vue"),
    meta: {
      title: "销售明细表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/suReportAnalyzeList",
    name: "suReportAnalyzeList",
    component: () =>
      import("../views/dataQuery/purchase/suReportAnalyzeList.vue"),
    meta: {
      title: "销售报表分析", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/salesMonthOverReport",
    name: "salesMonthOverReport",
    component: () =>
      import("../views/dataQuery/purchase/salesMonthOverReport.vue"),
    meta: {
      title: "销售环比查询", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/cusSalesRateReport",
    name: "cusSalesRateReport",
    component: () =>
      import("../views/dataQuery/purchase/cusSalesRateReport.vue"),
    meta: {
      title: "客商销售毛利分析表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/suDetailReportListUdi",
    name: "suDetailReportListUdi",
    component: () =>
      import("../views/dataQuery/purchase/suDetailReportListUdi.vue"),
    meta: {
      title: "销售财务明细报表UDI", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/cusSaleReceReport",
    name: "cusSaleReceReport",
    component: () =>
      import("../views/dataQuery/purchase/cusSaleReceReport.vue"),
    meta: {
      title: "客户销售回款分析", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/prodSalesReport",
    name: "prodSalesReport",
    component: () => import("../views/dataQuery/purchase/prodSalesReport.vue"),
    meta: {
      title: "产品销售数据分析", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/suGroupReport",
    name: "suGroupReport",
    component: () => import("../views/dataQuery/purchase/suGroupReport.vue"),
    meta: {
      title: "销售集团报表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/querySuDetailList",
    name: "querySuDetailList",
    component: () =>
      import("../views/dataQuery/purchase/querySuDetailList.vue"),
    meta: {
      title: "销售订单明细", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/suSummary",
    name: "suSummary",
    component: () => import("../views/dataQuery/purchase/suSummary.vue"),
    meta: {
      title: "销售汇总查询", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/suDetail",
    name: "suDetail",
    component: () => import("../views/dataQuery/purchase/suDetail.vue"),
    meta: {
      title: "销售明细查询", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/queryFinanceReportList",
    name: "queryFinanceReportList",
    component: () =>
      import("../views/dataQuery/purchase/queryFinanceReportList.vue"),
    meta: {
      title: "财务收款报表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/vehicleLicenseList",
    name: "vehicleLicenseList",
    component: () =>
      import("../views/stockUnit/vehicle/vehicleLicenseList.vue"),
    meta: {
      title: "车辆证照列表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/vehicleRepairList",
    name: "vehicleRepairList",
    component: () => import("../views/stockUnit/vehicle/vehicleRepairList.vue"),
    meta: {
      title: "车辆维修列表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/vehicleCuringList",
    name: "vehicleCuringList",
    component: () => import("../views/stockUnit/vehicle/vehicleCuringList.vue"),
    meta: {
      title: "车辆保养列表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/vehicleInsureList",
    name: "vehicleInsureList",
    component: () => import("../views/stockUnit/vehicle/vehicleInsureList.vue"),
    meta: {
      title: "车辆保养列表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/lotPriceList",
    name: "lotPriceList",
    component: () => import("../views/stockUnit/lotPrice/lotPriceList.vue"),
    meta: {
      title: "批次价格策略", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/suplicencelWarnList",
    name: "suplicencelWarnList",
    component: () =>
      import("../views/dataQuery/licenseWarning/suplicencelWarnList.vue"),
    meta: {
      title: "供货商证照预警", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/cuslicencelWarnList",
    name: "cuslicencelWarnList",
    component: () =>
      import("../views/dataQuery/licenseWarning/cuslicencelWarnList.vue"),
    meta: {
      title: "客户证照预警", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/busGoodsWarnList",
    name: "busGoodsWarnList",
    component: () =>
      import("../views/dataQuery/licenseWarning/busGoodsWarnList.vue"),
    meta: {
      title: "品种证照预警", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/manufacturerWarnList",
    name: "manufacturerWarnList",
    component: () =>
      import("../views/dataQuery/licenseWarning/manufacturerWarnList.vue"),
    meta: {
      title: "生产厂商预警", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/registerLicWarnList",
    name: "registerLicWarnList",
    component: () =>
      import("../views/dataQuery/licenseWarning/registerLicWarnList.vue"),
    meta: {
      title: "注册证预警", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/salesLicencelWarnList",
    name: "salesLicencelWarnList",
    component: () =>
      import("../views/dataQuery/licenseWarning/salesLicencelWarnList.vue"),
    meta: {
      title: "对方业务员证照预警", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/noLicencelWarnList",
    name: "noLicencelWarnList",
    component: () =>
      import("../views/dataQuery/licenseWarning/noLicencelWarnList.vue"),
    meta: {
      title: "无证照预警", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },

  {
    path: "/curingWarnList",
    name: "curingWarnList",
    component: () =>
      import("../views/dataQuery/maintenanceReminder/curingWarnList.vue"),
    meta: {
      title: "养护提醒", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },

  {
    path: "/stockTurnRateList",
    name: "stockTurnRateList",
    component: () =>
      import("../views/dataQuery/hisInventoryRecords/stockTurnRateList.vue"),
    meta: {
      title: "库存周转分析", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/stockHistoryList",
    name: "stockHistoryList",
    component: () =>
      import("../views/dataQuery/hisInventoryRecords/stockHistoryList.vue"),
    meta: {
      title: "历史库存列表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/overflowdetailed",
    name: "overflowdetailed",
    component: () =>
      import("../views/dataQuery/hisInventoryRecords/overflowdetailed.vue"),
    meta: {
      title: "损溢明细列表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/transferdetailed",
    name: "transferdetailed",
    component: () =>
      import("../views/dataQuery/hisInventoryRecords/transferdetailed.vue"),
    meta: {
      title: "移库明细列表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/packageStockList",
    name: "packageStockList",
    component: () =>
      import("../views/dataQuery/hisInventoryRecords/packageStockList.vue"),
    meta: {
      title: "库存包库存查询", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/qhgooodReportList",
    name: "qhgooodReportList",
    component: () =>
      import("../views/dataQuery/hisInventoryRecords/qhgooodReportList.vue"),
    meta: {
      title: "缺货品规查询", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/Inventorydetailed",
    name: "Inventorydetailed",
    component: () =>
      import("../views/dataQuery/hisInventoryRecords/Inventorydetailed.vue"),
    meta: {
      title: "盘点明细列表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/StockTurnoverList",
    name: "StockTurnoverList",
    component: () =>
      import("../views/dataQuery/hisInventoryRecords/StockTurnoverList.vue"),
    meta: {
      title: "商品总账流水列表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/batchnoStockList",
    name: "batchnoStockList",
    component: () =>
      import("../views/dataQuery/hisInventoryRecords/batchnoStockList.vue"),
    meta: {
      title: "批号库存", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/inventoryDetailReport",
    name: "inventoryDetailReport",
    component: () =>
      import("../views/dataQuery/hisInventoryRecords/inventoryDetailReport.vue"),
    meta: {
      title: "库存详情报表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/inTranStockList",
    name: "inTranStockList",
    component: () =>
      import("../views/dataQuery/hisInventoryRecords/inTranStockList.vue"),
    meta: {
      title: "在途库存查询", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/stockBlank",
    name: "stockBlank",
    component: () =>
      import("../views/dataQuery/hisInventoryRecords/stockBlank.vue"),
    meta: {
      title: "空出库存查询", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/wholeDismantleList",
    name: "wholeDismantleList",
    component: () =>
      import("../views/dataQuery/hisInventoryRecords/wholeDismantleList.vue"),
    meta: {
      title: "整件拆零", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/inOutFlowDirectionList",
    name: "inOutFlowDirectionList",
    component: () =>
      import(
        "../views/dataQuery/hisInventoryRecords/inOutFlowDirectionList.vue"
      ),
    meta: {
      title: "进销存流向查询", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/inOutFlowDirectionListNew",
    name: "inOutFlowDirectionListNew",
    component: () =>
      import(
        "../views/dataQuery/hisInventoryRecords/inOutFlowDirectionListNew.vue"
      ),
    meta: {
      title: "进销存流向查询(新)", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/queryGoodsAllStock",
    name: "queryGoodsAllStock",
    component: () =>
      import("../views/dataQuery/hisInventoryRecords/queryGoodsAllStock.vue"),
    meta: {
      title: "商品总库存", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/groupStockLReport",
    name: "groupStockLReport",
    component: () =>
      import("../views/dataQuery/hisInventoryRecords/groupStockLReport.vue"),
    meta: {
      title: "集团库存报表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/querySupFlowList",
    name: "querySupFlowList",
    component: () =>
      import("../views/dataQuery/hisInventoryRecords/querySupFlowList.vue"),
    meta: {
      title: "供应商流向查询", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/queryFlowDirection",
    name: "queryFlowDirection",
    component: () =>
      import("../views/dataQuery/hisInventoryRecords/queryFlowDirection.vue"),
    meta: {
      title: "商品流向", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/queryFlowDirectionNew",
    name: "queryFlowDirectionNew",
    component: () =>
      import(
        "../views/dataQuery/hisInventoryRecords/queryFlowDirectionNew.vue"
      ),
    meta: {
      title: "商品流向(新)", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/mancrealFlowReportList",
    name: "mancrealFlowReportList",
    component: () =>
      import("../views/dataQuery/hisInventoryRecords/mancrealFlowReportList.vue"),
    meta: {
      title: "厂家流向查询", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/queryGoodUnsalableList",
    name: "queryGoodUnsalableList",
    component: () =>
      import(
        "../views/dataQuery/hisInventoryRecords/queryGoodUnsalableList.vue"
      ),
    meta: {
      title: "商品滞销查询", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/queryOutStockAnalyzeList",
    name: "queryOutStockAnalyzeList",
    component: () =>
      import(
        "../views/dataQuery/hisInventoryRecords/queryOutStockAnalyzeList.vue"
      ),
    meta: {
      title: "缺货分析", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/transferDetailReportList",
    name: "transferDetailReportList",
    component: () =>
      import(
        "../views/dataQuery/hisInventoryRecords/transferDetailReportList.vue"
      ),
    meta: {
      title: "调拨明细记录", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/udiStockList",
    name: "udiStockList",
    component: () =>
      import(
        "../views/dataQuery/hisInventoryRecords/udiStockList.vue"
      ),
    meta: {
      title: "UDI库存查询", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/udiStockRecord",
    name: "udiStockRecord",
    component: () =>
      import(
        "../views/dataQuery/hisInventoryRecords/udiStockRecord.vue"
      ),
    meta: {
      title: "UDI库存流水查询", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/goodstockList",
    name: "goodstockList",
    component: () =>
      import("../views/dataQuery/hisInventoryRecords/goodstockList.vue"),
    meta: {
      title: "商品库存查询", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },

  // 货主调拨列表
  {
    path: "/coTransferList",
    name: "coTransferList",
    component: () => import("../views/dataQuery/coTransfer/coTransferList.vue"),
    meta: {
      title: "货主调拨列表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  // 货主调拨审核
  {
    path: "/coTransferTask",
    name: "coTransferTask",
    component: () => import("../views/dataQuery/coTransfer/coTransferTask.vue"),
    meta: {
      title: "货主调拨审核", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  // 货主调拨历史
  {
    path: "/coTransferHistory",
    name: "coTransferHistory",
    component: () =>
      import("../views/dataQuery/coTransfer/coTransferHistory.vue"),
    meta: {
      title: "货主调拨历史", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },

  // 报表
  {
    path: "/purchaseRecord",
    name: "purchaseRecord",
    component: () =>
      import("../views/gspUnit/businessRecord/purchaseRecord.vue"),
    meta: {
      title: "采购记录", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  // 报表
  {
    path: "/qualityReviewList",
    name: "qualityReviewList",
    component: () =>
      import("../views/gspUnit/businessRecord/qualityReviewList.vue"),
    meta: {
      title: "质量评审", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/receivingRecord",
    name: "receivingRecord",
    component: () =>
      import("../views/gspUnit/businessRecord/receivingRecord.vue"),
    meta: {
      title: "收货记录", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/checkRecord",
    name: "checkRecord",
    component: () => import("../views/gspUnit/businessRecord/checkRecord.vue"),
    meta: {
      title: "验收记录", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/backupReport1",
    name: "backupReport1",
    component: () => import("../views/gspUnit/businessRecord/backupReport1.vue"),
    meta: {
      title: "备用报表1", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/suBackRecord",
    name: "suBackRecord",
    component: () => import("../views/gspUnit/businessRecord/suBackRecord.vue"),
    meta: {
      title: "销售退回记录", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/purchaseWareRecord",
    name: "purchaseWareRecord",
    component: () =>
      import("../views/gspUnit/businessRecord/purchaseWareRecord.vue"),
    meta: {
      title: "采购入库记录", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/salesReturnReceivingRecord",
    name: "salesReturnReceivingRecord",
    component: () =>
      import("../views/gspUnit/businessRecord/salesReturnReceivingRecord.vue"),
    meta: {
      title: "销售退回收货记录", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/salesReturnCheckRecord",
    name: "salesReturnCheckRecord",
    component: () =>
      import("../views/gspUnit/businessRecord/salesReturnCheckRecord.vue"),
    meta: {
      title: "销售退回验收记录", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/salesReturnPurchaseRecord",
    name: "salesReturnPurchaseRecord",
    component: () =>
      import("../views/gspUnit/businessRecord/salesReturnPurchaseRecord.vue"),
    meta: {
      title: "销售退回入库记录", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/salesExWarehouseRecord",
    name: "salesExWarehouseRecord",
    component: () =>
      import("../views/gspUnit/businessRecord/salesExWarehouseRecord.vue"),
    meta: {
      title: "销售出库记录", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/salesExWareReviewRecord",
    name: "salesExWareReviewRecord",
    component: () =>
      import("../views/gspUnit/businessRecord/salesExWareReviewRecord.vue"),
    meta: {
      title: "销售出库复核记录", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/purchaseReturnRecord",
    name: "purchaseReturnRecord",
    component: () =>
      import("../views/gspUnit/businessRecord/purchaseReturnRecord.vue"),
    meta: {
      title: "采购退回记录", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/purchaseReturnReviewRecord",
    name: "purchaseReturnReviewRecord",
    component: () =>
      import("../views/gspUnit/businessRecord/purchaseReturnReviewRecord.vue"),
    meta: {
      title: "采购退回记录", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/receiptRecord",
    name: "receiptRecord",
    component: () =>
      import("../views/gspUnit/businessRecord/receiptRecord.vue"),
    meta: {
      title: "回执记录", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/coldChainList",
    name: "coldChainList",
    component: () =>
      import("../views/gspUnit/businessRecord/coldChainList.vue"),
    meta: {
      title: "冷链运输记录", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/wtlogisticChainList",
    name: "wtlogisticChainList",
    component: () =>
      import("../views/gspUnit/businessRecord/wtlogisticChainList.vue"),
    meta: {
      title: "wtlogisticChainList", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/returnRecordList",
    name: "returnRecordList",
    component: () =>
      import("../views/gspUnit/businessRecord/returnRecordList.vue"),
    meta: {
      title: "拒收记录", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/returnRecordInitList",
    name: "returnRecordInitList",
    component: () =>
      import("../views/gspUnit/businessRecord/returnRecordInitList.vue"),
    meta: {
      title: "拒收记录列表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/returnRecordInitHis",
    name: "returnRecordInitHis",
    component: () =>
      import("../views/gspUnit/businessRecord/returnRecordInitHis.vue"),
    meta: {
      title: "拒收记录历史", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/facilityReadinessConserve",
    name: "facilityReadinessConserve",
    component: () =>
      import("../views/gspUnit/businessRecord/facilityReadinessConserve.vue"),
    meta: {
      title: "设备设施养护", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/acceptanceConfirm",
    name: "acceptanceConfirm",
    component: () =>
      import("../views/gspUnit/businessRecord/acceptanceConfirm.vue"),
    meta: {
      title: "确认验收", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/jsList",
    name: "jsList",
    component: () =>
      import("../views/gspUnit/businessRecord/jsList.vue"),
    meta: {
      title: "商品拒收列表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/stockFileUpload",
    name: "stockFileUpload",
    component: () =>
      import("../views/gspUnit/businessRecord/stockFileUpload.vue"),
    meta: {
      title: "商品拒收列表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/klpuInvoice",
    name: "klpuInvoice",
    component: () =>
      import("../views/gspUnit/businessRecord/klpuInvoice.vue"),
    meta: {
      title: "期初采购发票登记", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/kpsuInvoice",
    name: "kpsuInvoice",
    component: () =>
      import("../views/gspUnit/businessRecord/kpsuInvoice.vue"),
    meta: {
      title: "期初销售发票登记", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/goodImport",
    name: "goodImport",
    component: () =>
      import("../views/gspUnit/businessRecord/goodImport.vue"),
    meta: {
      title: "商品拒收列表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/returnRecordAudit",
    name: "returnRecordAudit",
    component: () =>
      import("../views/gspUnit/businessRecord/returnRecordAudit.vue"),
    meta: {
      title: "拒收记录审核", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/goodsInHisList",
    name: "goodsInHisList",
    component: () =>
      import("../views/gspUnit/businessRecord/goodsInHisList.vue"),
    meta: {
      title: "商品采购记录", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/damagedRecord",
    name: "damagedRecord",
    component: () =>
      import("../views/gspUnit/businessRecord/damagedRecord.vue"),
    meta: {
      title: "不合格报损记录", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/destroyRecord",
    name: "destroyRecord",
    component: () =>
      import("../views/gspUnit/businessRecord/destroyRecord.vue"),
    meta: {
      title: "不合格销毁记录", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/curingRecordList",
    name: "curingRecordList",
    component: () =>
      import("../views/gspUnit/businessRecord/curingRecordList.vue"),
    meta: {
      title: "养护记录", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/operationRecordList",
    name: "operationRecordList",
    component: () =>
      import("../views/gspUnit/businessRecord/operationRecordList.vue"),
    meta: {
      title: "业务报表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/materialChangeRecodList",
    name: "materialChangeRecodList",
    component: () =>
      import("../views/gspUnit/businessRecord/materialChangeRecodList.vue"),
    meta: {
      title: "资料变更记录", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/recallRecordList",
    name: "recallRecordList",
    component: () =>
      import("../views/gspUnit/businessRecord/recallRecordList.vue"),
    meta: {
      title: "召回记录", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/stopRecordList",
    name: "stopRecordList",
    component: () =>
      import("../views/gspUnit/businessRecord/stopRecordList.vue"),
    meta: {
      title: "停售记录", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/urgingSalesList",
    name: "urgingSalesList",
    component: () =>
      import("../views/gspUnit/expeditingList/urgingSalesList.vue"),
    meta: {
      title: "近效期催销记录", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },

  // 预警
  {
    path: "/zhankuOverThreshold",
    name: "zhankuOverThreshold",
    component: () =>
      import("../views/dataQuery/inventoryWarning/zhankuOverThreshold.vue"),
    meta: {
      title: "占库超阀值", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/unsalableOverThreshold",
    name: "unsalableOverThreshold",
    component: () =>
      import("../views/dataQuery/inventoryWarning/unsalableOverThreshold.vue"),
    meta: {
      title: "滞销超阀值", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/inventoryExceptionAlert",
    name: "inventoryExceptionAlert",
    component: () =>
      import("../views/dataQuery/inventoryWarning/inventoryExceptionAlert.vue"),
    meta: {
      title: "库存异常预警", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/validityAnomalyWarning",
    name: "validityAnomalyWarning",
    component: () =>
      import("../views/dataQuery/inventoryWarning/validityAnomalyWarning.vue"),
    meta: {
      title: "效期异常预警", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },

  {
    path: "/purchaseSillCountList",
    name: "purchaseSillCountList",
    component: () =>
      import("../views/dataQuery/purchaseAlert/purchaseSillCountList.vue"),
    meta: {
      title: "采购数量超阈", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/purchaseSillMoneyList",
    name: "purchaseSillMoneyList",
    component: () =>
      import("../views/dataQuery/purchaseAlert/purchaseSillMoneyList.vue"),
    meta: {
      title: "采购金额超阈", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/puContractRpeortList",
    name: "puContractRpeortList",
    component: () =>
      import("../views/dataQuery/purchaseAlert/puContractRpeortList.vue"),
    meta: {
      title: "采购合同预警", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  // 超期未付款
  {
    path: "/beyondPayReportList",
    name: "beyondPayReportList",
    component: () =>
      import("../views/dataQuery/purchaseAlert/beyondPayReportList.vue"),
    meta: {
      title: "超期未付款", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/purchaseOvertakeList",
    name: "purchaseOvertakeList",
    component: () =>
      import("../views/dataQuery/purchaseAlert/purchaseOvertakeList.vue"),
    meta: {
      title: "超最后采购价", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/highLowestList",
    name: "highLowestList",
    component: () =>
      import("../views/dataQuery/purchaseAlert/highLowestList.vue"),
    meta: {
      title: "高于最低售价", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/lateDeliveryList",
    name: "lateDeliveryList",
    component: () =>
      import("../views/dataQuery/purchaseAlert/lateDeliveryList.vue"),
    meta: {
      title: "超期未到货", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/purchaseTimeOutList",
    name: "purchaseTimeOutList",
    component: () =>
      import("../views/dataQuery/purchaseAlert/purchaseTimeOutList.vue"),
    meta: {
      title: "采购订单超时", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/shortTermReturnList",
    name: "shortTermReturnList",
    component: () =>
      import("../views/dataQuery/purchaseAlert/shortTermReturnList.vue"),
    meta: {
      title: "短期内退货", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/outOfStockTimeoutList",
    name: "outOfStockTimeoutList",
    component: () =>
      import("../views/dataQuery/purchaseAlert/outOfStockTimeoutList.vue"),
    meta: {
      title: "缺货超时", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/salesBelowCostList",
    name: "salesBelowCostList",
    component: () =>
      import("../views/dataQuery/queryStatics/salesBelowCostList.vue"),
    meta: {
      title: "销售低于成本", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/suContractRpeortList",
    name: "suContractRpeortList",
    component: () =>
      import("../views/dataQuery/queryStatics/suContractRpeortList.vue"),
    meta: {
      title: "销售合同预警", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/salesOvertakeNumList",
    name: "salesOvertakeNumList",
    component: () =>
      import("../views/dataQuery/queryStatics/salesOvertakeNumList.vue"),
    meta: {
      title: "销售数量超阈值", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/salesOvertakeMoneyList",
    name: "salesOvertakeMoneyList",
    component: () =>
      import("../views/dataQuery/queryStatics/salesOvertakeMoneyList.vue"),
    meta: {
      title: "销售金额超阈值", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  // 超期未回款
  {
    path: "/beyondBackRperotList",
    name: "beyondBackRperotList",
    component: () =>
      import("../views/dataQuery/queryStatics/beyondBackRperotList.vue"),
    meta: {
      title: "超期未回款", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/salesAvgBeneathList",
    name: "salesAvgBeneathList",
    component: () =>
      import("../views/dataQuery/queryStatics/salesAvgBeneathList.vue"),
    meta: {
      title: "平均额低阈值", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/salesGrossBeneathList",
    name: "salesGrossBeneathList",
    component: () =>
      import("../views/dataQuery/queryStatics/salesGrossBeneathList.vue"),
    meta: {
      title: "毛利低于阈值", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/salesCreditamountList",
    name: "salesCreditamountList",
    component: () =>
      import("../views/dataQuery/queryStatics/salesCreditamountList.vue"),
    meta: {
      title: "信贷额超阈值", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/salesHangoutTimeoutList",
    name: "salesHangoutTimeoutList",
    component: () =>
      import("../views/dataQuery/queryStatics/salesHangoutTimeoutList.vue"),
    meta: {
      title: "订单挂账超时", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/salesShortTermReturn",
    name: "salesShortTermReturn",
    component: () =>
      import("../views/dataQuery/queryStatics/salesShortTermReturn.vue"),
    meta: {
      title: "短期内退货", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/inventoryReminder",
    name: "inventoryReminder",
    component: () =>
      import("../views/dataQuery/warehouseEarlyWarning/inventoryReminder.vue"),
    meta: {
      title: "盘点提醒", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/receiptTimeout",
    name: "receiptTimeout",
    component: () =>
      import("../views/dataQuery/warehouseEarlyWarning/receiptTimeout.vue"),
    meta: {
      title: "收货超时", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/acceptanceTimeout",
    name: "acceptanceTimeout",
    component: () =>
      import("../views/dataQuery/warehouseEarlyWarning/acceptanceTimeout.vue"),
    meta: {
      title: "验收超时", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/pickingTimeout",
    name: "pickingTimeout",
    component: () =>
      import("../views/dataQuery/warehouseEarlyWarning/pickingTimeout.vue"),
    meta: {
      title: "拣货超时", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/loadingTimeout",
    name: "loadingTimeout",
    component: () =>
      import("../views/dataQuery/warehouseEarlyWarning/loadingTimeout.vue"),
    meta: {
      title: "装车超时", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },

  {
    path: "/emcuringList",
    name: "emcuringList",
    component: () => import("../views/gspUnit/equipment/emcuringList.vue"),
    meta: {
      title: "设备设施养护", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/emrepairList",
    name: "emrepairList",
    component: () => import("../views/gspUnit/equipment/emrepairList.vue"),
    meta: {
      title: "设备设施维修", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },

  {
    path: "/emuseList",
    name: "emuseList",
    component: () => import("../views/gspUnit/equipment/emuseList.vue"),
    meta: {
      title: "设施设备使用", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/emscrapList",
    name: "emscrapList",
    component: () => import("../views/gspUnit/equipment/emscrapList.vue"),
    meta: {
      title: "设备设施报废", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/accountList",
    name: "accountList",
    component: () => import("../views/gspUnit/equipment/accountList.vue"),
    meta: {
      title: "设备设施台账", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },

  // 办公OA
  {
    path: "/officeOA",
    name: "officeOA",
    component: () => import("../views/modular.vue"),
    meta: {
      title: "办公OA", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },

  //办公物品采购办公物品采购
  {
    path: "/officeSuppliesPurchaseList",
    name: "officeSuppliesPurchaseList",
    component: () =>
      import(
        "../views/officeOA/officeSuppliesManagement/officeSuppliesPurchaseList.vue"
      ),
    meta: {
      title: "办公物品采购列表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/officeSuppliesPurchaseTask",
    name: "officeSuppliesPurchaseTask",
    component: () =>
      import(
        "../views/officeOA/officeSuppliesManagement/officeSuppliesPurchaseTask.vue"
      ),
    meta: {
      title: "办公物品采购审核", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/officeSuppliesPurchaseHis",
    name: "officeSuppliesPurchaseHis",
    component: () =>
      import(
        "../views/officeOA/officeSuppliesManagement/officeSuppliesPurchaseHis.vue"
      ),
    meta: {
      title: "办公物品采购历史", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },

  //办公物品领取
  {
    path: "/officeSuppliesCollectionList",
    name: "officeSuppliesCollectionList",
    component: () =>
      import(
        "../views/officeOA/officeSuppliesManagement/officeSuppliesCollectionList.vue"
      ),
    meta: {
      title: "办公物品领取列表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/officeSuppliesCollectionTask",
    name: "officeSuppliesCollectionTask",
    component: () =>
      import(
        "../views/officeOA/officeSuppliesManagement/officeSuppliesCollectionTask.vue"
      ),
    meta: {
      title: "办公物品领取审核", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/officeSuppliesCollectionHis",
    name: "officeSuppliesCollectionHis",
    component: () =>
      import(
        "../views/officeOA/officeSuppliesManagement/officeSuppliesCollectionHis.vue"
      ),
    meta: {
      title: "办公物品领取历史", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },

  //请假管理
  {
    path: "/staffLeaveList",
    name: "staffLeaveList",
    component: () =>
      import("../views/officeOA/staffLeaveManagement/staffLeaveList.vue"),
    meta: {
      title: "请假列表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/staffLeaveTask",
    name: "staffLeaveTask",
    component: () =>
      import("../views/officeOA/staffLeaveManagement/staffLeaveTask.vue"),
    meta: {
      title: "请假审核", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/staffLeaveHis",
    name: "staffLeaveHis",
    component: () =>
      import("../views/officeOA/staffLeaveManagement/staffLeaveHis.vue"),
    meta: {
      title: "请假历史", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },

  //访客管理
  {
    path: "/visitorList",
    name: "visitorList",
    component: () =>
      import("../views/officeOA/visitorManagement/visitorList.vue"),
    meta: {
      title: "访客列表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },

  //员工入职管理
  {
    path: "/employeeInductionList",
    name: "employeeInductionList",
    component: () =>
      import("../views/officeOA/personnelManagement/employeeInductionList.vue"),
    meta: {
      title: "员工入职列表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  //员工入职审核
  {
    path: "/employeeInductionTask",
    name: "employeeInductionTask",
    component: () =>
      import("../views/officeOA/personnelManagement/employeeInductionTask.vue"),
    meta: {
      title: "员工入职审核", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  //员工入职历史
  {
    path: "/employeeInductionHis",
    name: "employeeInductionHis",
    component: () =>
      import("../views/officeOA/personnelManagement/employeeInductionHis.vue"),
    meta: {
      title: "员工入职历史", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },

  //员工离职列表
  {
    path: "/employeeTurnoverList",
    name: "employeeTurnoverList",
    component: () =>
      import("../views/officeOA/personnelManagement/employeeTurnoverList.vue"),
    meta: {
      title: "员工离职列表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  //员工离职审核
  {
    path: "/employeeTurnoverTask",
    name: "employeeTurnoverTask",
    component: () =>
      import("../views/officeOA/personnelManagement/employeeTurnoverTask.vue"),
    meta: {
      title: "员工离职审核", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  //员工离职历史
  {
    path: "/employeeTurnoverHis",
    name: "employeeTurnoverHis",
    component: () =>
      import("../views/officeOA/personnelManagement/employeeTurnoverHis.vue"),
    meta: {
      title: "员工离职历史", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },

  //员工调岗申请列表
  {
    path: "/employeeTransferList",
    name: "employeeTransferList",
    component: () =>
      import("../views/officeOA/personnelManagement/employeeTransferList.vue"),
    meta: {
      title: "员工调岗列表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  //员工调岗申请审核
  {
    path: "/employeeTransferTask",
    name: "employeeTransferTask",
    component: () =>
      import("../views/officeOA/personnelManagement/employeeTransferTask.vue"),
    meta: {
      title: "员工调岗审核", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  //员工调岗申请历史
  {
    path: "/employeeTransferHis",
    name: "employeeTransferHis",
    component: () =>
      import("../views/officeOA/personnelManagement/employeeTransferHis.vue"),
    meta: {
      title: "员工调岗历史", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },

  //获取报销申请列表
  {
    path: "/claimList",
    name: "claimList",
    component: () =>
      import("../views/officeOA/claimReimbursement/claimList.vue"),
    meta: {
      title: "报销列表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  //报销申请审核
  {
    path: "/claimTask",
    name: "claimTask",
    component: () =>
      import("../views/officeOA/claimReimbursement/claimTask.vue"),
    meta: {
      title: "报销审核", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  //报销申请历史
  {
    path: "/claimHis",
    name: "claimHis",
    component: () =>
      import("../views/officeOA/claimReimbursement/claimHis.vue"),
    meta: {
      title: "报销历史", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },

  //出差、外出列表
  {
    path: "/travelList",
    name: "travelList",
    component: () =>
      import("../views/officeOA/travelManagement/travelList.vue"),
    meta: {
      title: "出差列表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  //出差、外出审核
  {
    path: "/travelTask",
    name: "travelTask",
    component: () =>
      import("../views/officeOA/travelManagement/travelTask.vue"),
    meta: {
      title: "出差审核", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  //出差、外出历史
  {
    path: "/travelHis",
    name: "travelHis",
    component: () => import("../views/officeOA/travelManagement/travelHis.vue"),
    meta: {
      title: "出差历史", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },

  //办公车辆列表
  {
    path: "/officeVehicleList",
    name: "officeVehicleList",
    component: () =>
      import("../views/officeOA/vehicleManagement/officeVehicleList.vue"),
    meta: {
      title: "办公车辆列表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  //办公车辆审核
  {
    path: "/officeVehicleTask",
    name: "officeVehicleTask",
    component: () =>
      import("../views/officeOA/vehicleManagement/officeVehicleTask.vue"),
    meta: {
      title: "办公车辆审核", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  //办公车辆历史
  {
    path: "/officeVehicleHis",
    name: "officeVehicleHis",
    component: () =>
      import("../views/officeOA/vehicleManagement/officeVehicleHis.vue"),
    meta: {
      title: "办公车辆历史", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/soldOutButBotPaidList",
    name: "soldOutButBotPaidList",
    component: () => import("../views/financeUnit/soldOutButBotPaidList.vue"),
    meta: {
      title: "销完未付款", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/unsettledCashList",
    name: "unsettledCashList",
    component: () => import("../views/financeUnit/unsettledCashList.vue"),
    meta: {
      title: "现金未计算", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/creditLimitErrorList",
    name: "creditLimitErrorList",
    component: () => import("../views/financeUnit/creditLimitErrorList.vue"),
    meta: {
      title: "信贷额异常", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/creditPeriodErrorList",
    name: "creditPeriodErrorList",
    component: () => import("../views/financeUnit/creditPeriodErrorList.vue"),
    meta: {
      title: "信贷期异常", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/paymentTimedOutList",
    name: "paymentTimedOutList",
    component: () => import("../views/financeUnit/paymentTimedOutList.vue"),
    meta: {
      title: "付款超时", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/collectionTimeoutList",
    name: "collectionTimeoutList",
    component: () => import("../views/financeUnit/collectionTimeoutList.vue"),
    meta: {
      title: "收款超时", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/subscriptTimeOutList",
    name: "subscriptTimeOutList",
    component: () => import("../views/financeUnit/subscriptTimeOutList.vue"),
    meta: {
      title: "认款超时", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/goodTimeoutList",
    name: "goodTimeoutList",
    component: () => import("../views/financeUnit/goodTimeoutList.vue"),
    meta: {
      title: "首营商品超时", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/unitTimeoutList",
    name: "unitTimeoutList",
    component: () => import("../views/financeUnit/unitTimeoutList.vue"),
    meta: {
      title: "首营单位超时", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/discontinuedTimeoutList",
    name: "discontinuedTimeoutList",
    component: () => import("../views/financeUnit/discontinuedTimeoutList.vue"),
    meta: {
      title: "停售超时", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/unqualifiedTimeoutList",
    name: "unqualifiedTimeoutList",
    component: () => import("../views/financeUnit/unqualifiedTimeoutList.vue"),
    meta: {
      title: "不合格处理超时", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/cusTimeoutList",
    name: "cusTimeoutList",
    component: () => import("../views/financeUnit/cusTimeoutList.vue"),
    meta: {
      title: "客户审批超时", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/receiptTimeoutList",
    name: "receiptTimeoutList",
    component: () => import("../views/financeUnit/receiptTimeoutList.vue"),
    meta: {
      title: "回执登记超时", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },

  // 通知协作
  {
    path: "/noticeCooperation",
    name: "noticeCooperation",
    component: () => import("../views/modular.vue"),
    meta: {
      title: "通知协作", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  //公告
  {
    path: "/noticeList",
    name: "noticeList",
    component: () => import("../views/noticeCooperation/notice/noticeList.vue"),
    meta: {
      title: "公告列表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },

  // 协同办公
  {
    path: "/collOffice",
    name: "collOffice",
    component: () => import("../views/modular.vue"),
    meta: {
      title: "协同办公", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },

  // 采购报表分析
  {
    path: "/xtPuReportList",
    name: "xtPuReportList",
    component: () =>
      import("../views/collOffice/purchaseReport/xtPuReportList.vue"),
    meta: {
      title: "采购报表分析", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },

  // 采购明细表
  {
    path: "/xtPuDetailReportList",
    name: "xtPuDetailReportList",
    component: () =>
      import("../views/collOffice/purchaseReport/xtPuDetailReportList.vue"),
    meta: {
      title: "采购明细表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },

  // 销售报表分析
  {
    path: "/xtSuReportList",
    name: "xtSuReportList",
    component: () =>
      import("../views/collOffice/salesReport/xtSuReportList.vue"),
    meta: {
      title: "销售报表分析", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },

  // 销售明细表
  {
    path: "/xtSuDetailReportList",
    name: "xtSuDetailReportList",
    component: () =>
      import("../views/collOffice/salesReport/xtSuDetailReportList.vue"),
    meta: {
      title: "销售明细表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },

  // 历史库存列表
  {
    path: "/xtHistoryStockReportList",
    name: "xtHistoryStockReportList",
    component: () =>
      import("../views/collOffice/stockReport/xtHistoryStockReportList.vue"),
    meta: {
      title: "历史库存列表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },

  // 供货商证照预警
  {
    path: "/xtSupReportList",
    name: "xtSupReportList",
    component: () =>
      import("../views/collOffice/warnReport/xtSupReportList.vue"),
    meta: {
      title: "供货商证照预警", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },

  // 客户证照预警
  {
    path: "/xtCusReportList",
    name: "xtCusReportList",
    component: () =>
      import("../views/collOffice/warnReport/xtCusReportList.vue"),
    meta: {
      title: "客户证照预警", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },

  // 品种证照预警
  {
    path: "/xtGoodsReportList",
    name: "xtGoodsReportList",
    component: () =>
      import("../views/collOffice/warnReport/xtGoodsReportList.vue"),
    meta: {
      title: "品种证照预警", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },

  // 流向记录列表
  {
    path: "/xtPurchaRecordReportList",
    name: "xtPurchaRecordReportList",
    component: () =>
      import("../views/collOffice/flowReport/xtPurchaRecordReportList.vue"),
    meta: {
      title: "流向记录列表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  // 发票报表
  {
    path: "/invoiceReportList",
    name: "invoiceReportList",
    component: () =>
      import("../views/collOffice/flowReport/invoiceReportList.vue"),
    meta: {
      title: "发票报表列表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  // 质检报告报表
  {
    path: "/qualityInspectionList",
    name: "qualityInspectionList",
    component: () =>
      import(
        "../views/collOffice/QualityInspectionReport/qualityInspectionList.vue"
      ),
    meta: {
      title: "发票报表列表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  // 帮助文档管理
  {
    path: "/queryHelpDocument",
    name: "queryHelpDocument",
    component: () =>
      import(
        "../views/noticeCooperation/noticeCooperation/queryHelpDocument.vue"
      ),
    meta: {
      title: "帮助文档管理", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  // 系统设置
  {
    path: "/systemSettings",
    name: "systemSettings",
    component: () => import("../views/optionSettings/systemSettings.vue"),
    meta: {
      title: "系统设置", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  // 拦截规则
  {
    path: "/interceptRule",
    name: "interceptRule",
    component: () => import("../views/optionSettings/interceptRule.vue"),
    meta: {
      title: "拦截规则", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  // 打印方案
  {
    path: "/printScheme",
    name: "printScheme",
    component: () => import("../views/optionSettings/printScheme.vue"),
    meta: {
      title: "打印方案", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  // 解除占用
  {
    path: "/rescindOccupy",
    name: "rescindOccupy",
    component: () => import("../views/optionSettings/rescindOccupy.vue"),
    meta: {
      title: "解除占用", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/interfacemonitoring",
    name: "interfacemonitoring",
    component: () => import("../views/optionSettings/interfacemonitoring.vue"),
    meta: {
      title: "接口监控", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/medicalInsuranceSettlementRecord",
    name: "medicalInsuranceSettlementRecord",
    component: () => import("../views/optionSettings/medicalInsuranceSettlementRecord.vue"),
    meta: {
      title: "医保结算记录", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/medicalInsuranceSettleRecord",
    name: "medicalInsuranceSettleRecord",
    component: () => import("../views/optionSettings/medicalInsuranceSettleRecord.vue"),
    meta: {
      title: "医保对账单", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/gyxnCancelOrder",
    name: "gyxnCancelOrder",
    component: () => import("../views/optionSettings/gyxnCancelOrder.vue"),
    meta: {
      title: "国药取消订单", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  // 库存占用明细
  {
    path: "/stockOccupyData",
    name: "stockOccupyData",
    component: () => import("../views/optionSettings/stockOccupyData"),
    meta: {
      title: "库存占用明细", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  // 期初管理
  {
    path: "/initDataGl",
    name: "initDataGl",
    component: () => import("../views/optionSettings/initDataGl"),
    meta: {
      title: "期初管理", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  // 清除数据页面
  {
    path: "/clearData",
    name: "clearData",
    component: () => import("../views/optionSettings/clearData"),
    meta: {
      title: "清除数据", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  // 订单时间管理
  {
    path: "/orderTimeUpdatePage",
    name: "orderTimeUpdatePage",
    component: () => import("../views/optionSettings/orderTimeUpdatePage"),
    meta: {
      title: "订单时间管理", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  // 采购税率变更
  {
    path: "/inRateChangeList",
    name: "inRateChangeList",
    component: () => import("../views/optionSettings/inRateChangeList.vue"),
    meta: {
      title: "采购税率变更", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  // 销售税率变更
  {
    path: "/outRateChangeList",
    name: "outRateChangeList",
    component: () => import("../views/optionSettings/outRateChangeList.vue"),
    meta: {
      title: "采购税率变更", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  // 订阅信息设置
  {
    path: "/subscribeData",
    name: "subscribeData",
    component: () => import("../views/optionSettings/subscribeData.vue"),
    meta: {
      title: "订阅信息设置", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  // 信息调整
  {
    path: "/gspTimeUpdate",
    name: "gspTimeUpdate",
    component: () => import("../views/optionSettings/gspTimeUpdate.vue"),
    meta: {
      title: "信息调整", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  // 出库流向报表
  {
    path: "/wobkeflowtempList",
    name: "wobkeflowtempList",
    component: () => import("../views/optionSettings/wobkeflowtempList.vue"),
    meta: {
      title: "出库流向报表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  //货主扣费标准
  {
    path: "/ownerdeductionrule",
    name: "ownerdeductionrule",
    component: () => import("../views/optionSettings//ownerdeductionrule.vue"),
    meta: {
      title: "货主扣费标准", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  //仓库重传
  {
    path: "/stashRetransmission",
    name: "stashRetransmission",
    component: () => import("../views/optionSettings//stashRetransmission.vue"),
    meta: {
      title: "仓库重传", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  // 账套管理
  {
    path: "/sleeveManage",
    name: "sleeveManage",
    component: () => import("../views/optionSettings/sleeveManage.vue"),
    meta: {
      title: "账套管理", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  // 方案管理
  {
    path: "/schemeManage",
    name: "schemeManage",
    component: () => import("../views/optionSettings/schemeManage.vue"),
    meta: {
      title: "方案管理", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  // 恢复方案管理
  {
    path: "/schemeRecoverManage",
    name: "schemeRecoverManage",
    component: () => import("../views/optionSettings/schemeRecoverManage.vue"),
    meta: {
      title: "恢复方案管理", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  // 流程管理
  {
    path: "/businessProcess",
    name: "businessProcess",
    component: () => import("../views/optionSettings/businessProcess.vue"),
    meta: {
      title: "流程管理", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  // 销售流水
  {
    path: "/salesFlow",
    name: "salesFlow",
    component: () =>
      import("../views/financeUnit/subscriptionManage/salesFlow.vue"),
    meta: {
      title: "回款流水", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  // 现金流水
  {
    path: "/cashFlow",
    name: "cashFlow",
    component: () =>
      import("../views/financeUnit/subscriptionManage/cashFlow.vue"),
    meta: {
      title: "现金流水", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  // 认款记账
  {
    path: "/subscriptionBookkeep",
    name: "subscriptionBookkeep",
    component: () =>
      import(
        "../views/financeUnit/subscriptionManage/subscriptionBookkeep.vue"
      ),
    meta: {
      title: "认款记账", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  // 认款记账历史
  {
    path: "/subscriptionHis",
    name: "subscriptionHis",
    component: () =>
      import("../views/financeUnit/subscriptionManage/subscriptionHis.vue"),
    meta: {
      title: "认款记账历史", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  // 认款结算
  {
    path: "/subscriptionSettlement",
    name: "subscriptionSettlement",
    component: () =>
      import(
        "../views/financeUnit/subscriptionManage/subscriptionSettlement.vue"
      ),
    meta: {
      title: "认款结算", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  // 认款列表
  {
    path: "/subscriptionList",
    name: "subscriptionList",
    component: () =>
      import("../views/financeUnit/subscriptionManage/subscriptionList.vue"),
    meta: {
      title: "认款列表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  // 回款修改记录
  {
    path: "/runWateUpdRecord",
    name: "runWateUpdRecord",
    component: () =>
      import("../views/financeUnit/subscriptionManage/runWateUpdRecord.vue"),
    meta: {
      title: "回款修改记录", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  // 费用票查询
  {
    path: "/financialFeeTicketList",
    name: "financialFeeTicketList",
    component: () =>
      import("../views/financeUnit/expenseTicket/financialFeeTicketList.vue"),
    meta: {
      title: "费用票查询", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  // 费用票审核
  {
    path: "/feeTicketAudit",
    name: "feeTicketAudit",
    component: () =>
      import("../views/financeUnit/expenseTicket/feeTicketAudit.vue"),
    meta: {
      title: "费用票登记审核", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  // 费用票记账
  {
    path: "/feeTicketBookkeeping",
    name: "feeTicketBookkeeping",
    component: () =>
      import("../views/financeUnit/expenseTicket/feeTicketBookkeeping.vue"),
    meta: {
      title: "费用票记账", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  // 卸车单记录
  {
    path: "/unloadingRecordData",
    name: "unloadingRecordData",
    component: () =>
      import("../views/storageRoom/HandlingManagement/unloadingRecordData.vue"),
    meta: {
      title: "卸车单记录", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  // 费用票历史
  {
    path: "/feeTicketHis",
    name: "feeTicketHis",
    component: () =>
      import("../views/financeUnit/expenseTicket/feeTicketHis.vue"),
    meta: {
      title: "费用票登记历史", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/suRecord",
    name: "suRecord",
    component: () => import("../views/gspUnit/businessRecord/suRecord.vue"),
    meta: {
      title: "销售记录", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    //盘点记录
    path: "/takeStockRecord",
    name: "takeStockRecord",
    component: () =>
      import("../views/gspUnit/businessRecord/takeStockRecord.vue"),
    meta: {
      title: "销售记录", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    //udi
    path: "/udiCodeList",
    name: "udiCodeList",
    component: () => import("../views/gspUnit/businessRecord/udiCodeList.vue"),
    meta: {
      title: "销售记录", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    //udi
    path: "/suUdiListRecord",
    name: "suUdiListRecord",
    component: () => import("../views/gspUnit/businessRecord/suUdiListRecord.vue"),
    meta: {
      title: "UDI出库记录", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    //udi
    path: "/tmscoldChainList",
    name: "tmscoldChainList",
    component: () => import("../views/tms/tmscoldChainList.vue"),
    meta: {
      title: "TMS运输记录", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    //udi
    path: "/tmscoldChainList_SF",
    name: "tmscoldChainList_SF",
    component: () => import("../views/tms/tmscoldChainList_SF.vue"),
    meta: {
      title: "第三方TMS运输记录", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/querSuHighvalueList",
    name: "querSuHighvalueList",
    component: () =>
      import("../views/salesUnit/querSuHighvalue/querSuHighvalueList.vue"),
    meta: {
      title: "出库申请列表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/querAfterSaleList",
    name: "querAfterSaleList",
    component: () =>
      import("../views/salesUnit/querSuHighvalue/querAfterSaleList.vue"),
    meta: {
      title: "完善售后信息", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/querMoneysettlement",
    name: "querMoneysettlement",
    component: () =>
      import("../views/salesUnit/querSuHighvalue/querMoneysettlement.vue"),
    meta: {
      title: "费用核算", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/querRecycleList",
    name: "querRecycleList",
    component: () =>
      import("../views/salesUnit/querSuHighvalue/querRecycleList.vue"),
    meta: {
      title: "回库申请列表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/quasupplier",
    name: "quasupplier",
    component: () => import("../views/dataQuery/purchase/quasupplier.vue"),
    meta: {
      title: "合格供货方", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/quacustomer",
    name: "quacustomer",
    component: () => import("../views/dataQuery/purchase/quacustomer.vue"),
    meta: {
      title: "合格购货方", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/recoveryRecord",
    name: "recoveryRecord",
    component: () =>
      import("../views/gspUnit/businessRecord/recoveryRecord.vue"),
    meta: {
      title: "追回记录", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/unqualifiedLedger",
    name: "unqualifiedLedger",
    component: () =>
      import("../views/gspUnit/businessRecord/unqualifiedLedger.vue"),
    meta: {
      title: "不合格台账", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/outboundApplyReport",
    name: "outboundApplyReport",
    component: () =>
      import("../views/gspUnit/businessRecord/outboundApplyReport.vue"),
    meta: {
      title: "确认验收", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/costFeeList",
    name: "costFeeList",
    component: () =>
      import("../views/gspUnit/businessRecord/costFeeList.vue"),
    meta: {
      title: "WMS费用登记记录", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/zdlbList",
    name: "zdlbList",
    component: () => import("../views/purchasing/zdList/zdlbList.vue"),
    meta: {
      title: "直调出库列表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/operCreditList",
    name: "operCreditList",
    component: () =>
      import("../views/organizationalStructure/operCreditList.vue"),
    meta: {
      title: "业务员授信", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/zdysList",
    name: "zdysList",
    component: () => import("../views/purchasing/zdList/zdysList.vue"),
    meta: {
      title: "直调出库验收", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/zdthList",
    name: "zdthList",
    component: () => import("../views/purchasing/zdList/zdthList.vue"),
    meta: {
      title: "直调退货列表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/zdthysList",
    name: "zdthysList",
    component: () => import("../views/purchasing/zdList/zdthysList.vue"),
    meta: {
      title: "直调退货验收列表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/zdcgjlList",
    name: "zdcgjlList",
    component: () => import("../views/purchasing/zdList/zdcgjlList.vue"),
    meta: {
      title: "直调采购记录", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/zdysjlList",
    name: "zdysjlList",
    component: () => import("../views/purchasing/zdList/zdysjlList.vue"),
    meta: {
      title: "直调验收记录", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/zjxsjlList",
    name: "zjxsjlList",
    component: () => import("../views/purchasing/zdList/zjxsjlList.vue"),
    meta: {
      title: "直调销售记录", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/zjthjlList",
    name: "zjthjlList",
    component: () => import("../views/purchasing/zdList/zjthjlList.vue"),
    meta: {
      title: "直调退货记录", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/zjthysjlList",
    name: "zjthysjlList",
    component: () => import("../views/purchasing/zdList/zjthysjlList.vue"),
    meta: {
      title: "直调退货验收记录", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/supStateRecore",
    name: "supStateRecore",
    component: () => import("../views/unitData/supStateRecore.vue"),
    meta: {
      title: "状态变更记录", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/goodsStateRecord",
    name: "goodsStateRecord",
    component: () => import("../views/productionData/goodsStateRecord.vue"),
    meta: {
      title: "状态变更记录", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/stockPackageList",
    name: "stockPackageList",
    component: () => import("../views/productionData/stockPackageList.vue"),
    meta: {
      title: "库存包列表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/categoryManage",
    name: "categoryManage",
    component: () => import("../views/productionData/categoryManage.vue"),
    meta: {
      title: "分类管理", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/stockTrack",
    name: "stockTrack",
    component: () => import("../views/productionData/stockTrack.vue"),
    meta: {
      title: "商品库存追踪", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/goodsStockAnalyzeReport",
    name: "goodsStockAnalyzeReport",
    component: () => import("../views/productionData/goodsStockAnalyzeReport.vue"),
    meta: {
      title: "库存包列表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/jxcRpeortList",
    name: "jxcRpeortList",
    component: () => import("../views/productionData/jxcRpeortList.vue"),
    meta: {
      title: "系统进销存报表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/cuStateRecore",
    name: "cuStateRecore",
    component: () => import("../views/unitData/cuStateRecore.vue"),
    meta: {
      title: "状态变更记录", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/storeLocationList",
    name: "storeLocationList",
    component: () => import("../views/otherData/storeLocationList.vue"),
    meta: {
      title: "货位列表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/slAdjustList",
    name: "slAdjustList",
    component: () => import("../views/otherData/slAdjustList.vue"),
    meta: {
      title: "货位调整", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/stockMoveReport",
    name: "stockMoveReport",
    component: () => import("../views/otherData/stockMoveReport.vue"),
    meta: {
      title: "库存移库明细报表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/qualifapplyInitList",
    name: "qualifapplyInitList",
    component: () => import("../views/unitData/qualifapplyInitList.vue"),
    meta: {
      title: "资质申领列表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/qualifapplyTaskList",
    name: "qualifapplyTaskList",
    component: () => import("../views/unitData/qualifapplyTaskList.vue"),
    meta: {
      title: "资质申领列表审核", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/qualifapplyDownTaskList",
    name: "qualifapplyDownTaskList",
    component: () => import("../views/unitData/qualifapplyDownTaskList.vue"),
    meta: {
      title: "资质申领列表审核", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/qualifapplyHisList",
    name: "qualifapplyHisList",
    component: () => import("../views/unitData/qualifapplyHisList.vue"),
    meta: {
      title: "资质申领列表审核", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/storeManager",
    name: "storeManager",
    component: () => import("../views/modular.vue"),
    meta: {
      title: "门店模块", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/storeRequestRecord",
    name: "storeRequestRecord",
    component: () => import("../views/storeManager/storeRequestRecord.vue"),
    meta: {
      title: "门店请货记录", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/storeReturnRecord",
    name: "storeReturnRecord",
    component: () => import("../views/storeManager/storeReturnRecord.vue"),
    meta: {
      title: "门店退货记录", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/storeStockRecord",
    name: "storeStockRecord",
    component: () => import("../views/storeManager/storeStockRecord.vue"),
    meta: {
      title: "门店库存记录", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/storeRecevieRecord",
    name: "storeRecevieRecord",
    component: () => import("../views/storeManager/storeRecevieRecord.vue"),
    meta: {
      title: "门店收货记录", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/storeAcceptRecord",
    name: "storeAcceptRecord",
    component: () => import("../views/storeManager/storeAcceptRecord.vue"),
    meta: {
      title: "门店验收记录", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/storeInputRecord",
    name: "storeInputRecord",
    component: () => import("../views/storeManager/storeInputRecord.vue"),
    meta: {
      title: "门店入库记录", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/storeSalesRecord",
    name: "storeSalesRecord",
    component: () => import("../views/storeManager/storeSalesRecord.vue"),
    meta: {
      title: "门店销售记录", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/storeSpecialRecord",
    name: "storeSpecialRecord",
    component: () => import("../views/storeManager/storeSpecialRecord.vue"),
    meta: {
      title: "特管品种销售记录", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/storePrescriptRecord",
    name: "storePrescriptRecord",
    component: () => import("../views/storeManager/storePrescriptRecord.vue"),
    meta: {
      title: "处方品种销售记录", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/storeTraditRecord",
    name: "storeTraditRecord",
    component: () => import("../views/storeManager/storeTraditRecord.vue"),
    meta: {
      title: "中药饮片销售记录", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/storeColdRecord",
    name: "storeColdRecord",
    component: () => import("../views/storeManager/storeColdRecord.vue"),
    meta: {
      title: "冷藏品种销售记录", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/storeSplitRecord",
    name: "storeSplitRecord",
    component: () => import("../views/storeManager/storeSplitRecord.vue"),
    meta: {
      title: "拆零品种销售记录", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/storeCheckRecord",
    name: "storeCheckRecord",
    component: () => import("../views/storeManager/storeCheckRecord.vue"),
    meta: {
      title: "门店盘点记录", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/storeDisplayRecord",
    name: "storeDisplayRecord",
    component: () => import("../views/storeManager/storeDisplayRecord.vue"),
    meta: {
      title: "门店陈列记录", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/storeRejectRecord",
    name: "storeRejectRecord",
    component: () => import("../views/storeManager/storeRejectRecord.vue"),
    meta: {
      title: "门店不合格品记录", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/storeDeliveryList",
    name: "storeDeliveryList",
    component: () =>
      import("../views/storeManager/storeDeliveryList/storeDeliveryList.vue"),
    meta: {
      title: "门店配送单", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/storeDeliveryAudit",
    name: "storeDeliveryAudit",
    component: () =>
      import("../views/storeManager/storeDeliveryAudit/storeDeliveryAudit.vue"),
    meta: {
      title: "配送单审核", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/storeDeliveryHis",
    name: "storeDeliveryHis",
    component: () =>
      import("../views/storeManager/storeDeliveryHis/storeDeliveryHis.vue"),
    meta: {
      title: "配送单历史", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/storeReturnList",
    name: "storeReturnList",
    component: () =>
      import("../views/storeManager/storeReturnList/storeReturnList.vue"),
    meta: {
      title: "门店退货单", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/storeReturnAudit",
    name: "storeReturnAudit",
    component: () =>
      import("../views/storeManager/storeReturnAudit/storeReturnAudit.vue"),
    meta: {
      title: "退货单审核", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/storeReturnHis",
    name: "storeReturnHis",
    component: () =>
      import("../views/storeManager/storeReturnHis/storeReturnHis.vue"),
    meta: {
      title: "退货单历史", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/suCommerceReport",
    name: "suCommerceReport",
    component: () =>
      import("../views/salesUnit/salesOrder/suCommerceReport.vue"),
    meta: {
      title: "电商销售查询报表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  // 销售税率变更
  {
    path: "/bankReadRule",
    name: "bankReadRule",
    component: () => import("../views/optionSettings/bankReadRule.vue"),
    meta: {
      title: "采购税率变更", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  // 财务报表
  {
    path: "/supplyOwnerCurrentAccount",
    name: "supplyOwnerCurrentAccount",
    component: () =>
      import("../views/financeUnit/statements/supplyOwnerCurrentAccount.vue"),
    meta: {
      title: "供货商货主应付款分析", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  // 财务报表
  {
    path: "/customerOwnerCurrentAccount",
    name: "customerOwnerCurrentAccount",
    component: () =>
      import("../views/financeUnit/statements/customerOwnerCurrentAccount.vue"),
    meta: {
      title: "客户货主应付款分析", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/queryBorrowedSalesReportList",
    name: "queryBorrowedSalesReportList",
    component: () =>
      import("../views/dataQuery/purchase/queryBorrowedSalesReportList.vue"),
    meta: {
      title: "销售报表分析", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/xsorderDetailList",
    name: "xsorderDetailList",
    component: () =>
      import("../views/dataQuery/purchase/xsorderDetailList.vue"),
    meta: {
      title: "销售报表分析", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/passGoods",
    name: "passGoods",
    component: () => import("../views/dataQuery/purchase/passGoods.vue"),
    meta: {
      title: "销售报表分析", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  // 退款结算
  {
    path: "/refundSettlement",
    name: "refundSettlement",
    component: () =>
      import("../views/financeUnit/subscriptionManage/refundSettlement.vue"),
    meta: {
      title: "退款结算", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/salesRefundApplyInitList",
    name: "salesRefundApplyInitList",
    component: () =>
      import("../views/salesUnit/salesRefund/salesRefundApplyInitList.vue"),
    meta: {
      title: "退款申请列表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/salesRefundApplyAuditList",
    name: "salesRefundApplyAuditList",
    component: () =>
      import("../views/salesUnit/salesRefund/salesRefundApplyAuditList.vue"),
    meta: {
      title: "退款申请审核", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/salesRefundApplyHistList",
    name: "salesRefundApplyHistList",
    component: () =>
      import("../views/salesUnit/salesRefund/salesRefundApplyHistList.vue"),
    meta: {
      title: "退款申请历史", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/salesRefundAccount",
    name: "salesRefundAccount",
    component: () =>
      import("../views/salesUnit/salesRefund/salesRefundAccount.vue"),
    meta: {
      title: "退款记账历史", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/salesRefundList",
    name: "salesRefundList",
    component: () =>
      import("../views/salesUnit/salesRefund/salesRefundList.vue"),
    meta: {
      title: "退款记账历史", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/salesRefundSettlelList",
    name: "salesRefundSettlelList",
    component: () =>
      import("../views/salesUnit/salesRefund/salesRefundSettlelList.vue"),
    meta: {
      title: "退款记账历史", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/prepayOrderNormal",
    name: "prepayOrderNormal",
    component: () =>
      import("../views/purchasing/purchasePayment/prepayOrderNormal.vue"),
    meta: {
      title: "预付款结算", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/prepayOrderNormalList",
    name: "prepayOrderNormalList",
    component: () =>
      import("../views/purchasing/purchasePayment/prepayOrderNormalList.vue"),
    meta: {
      title: "预付匹配记录", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/puApplayUditList",
    name: "puApplayUditList",
    component: () => import("../views/productionData/puApplayUditList.vue"),
    meta: {
      title: "采购上传", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/stockApplayUditList",
    name: "stockApplayUditList",
    component: () => import("../views/productionData/stockApplayUditList.vue"),
    meta: {
      title: "库存上传", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/suApplayUditList",
    name: "suApplayUditList",
    component: () => import("../views/productionData/suApplayUditList.vue"),
    meta: {
      title: "销售上传", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/udiFilwDown",
    name: "udiFilwDown",
    component: () => import("../views/productionData/udiFilwDown.vue"),
    meta: {
      title: "文件下载", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/puInvoiceReport",
    name: "puInvoiceReport",
    component: () =>
      import("../views/financeUnit/statements/puInvoiceReport.vue"),
    meta: {
      title: "采购发票明细", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/suInvoiceQkReport",
    name: "suInvoiceQkReport",
    component: () =>
      import("../views/financeUnit/statements/suInvoiceQkReport.vue"),
    meta: {
      title: "销售发票明细", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  // 回款流水查询
  {
    path: "/runWaterHisRecord",
    name: "runWaterHisRecord",
    component: () =>
      import("../views/financeUnit/subscriptionManage/runWaterHisRecord.vue"),
    meta: {
      title: "回款流水查询", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  // 认款匹配查询
  {
    path: "/runWaterMatchRecord",
    name: "runWaterMatchRecord",
    component: () =>
      import("../views/financeUnit/subscriptionManage/runWaterMatchRecord.vue"),
    meta: {
      title: "认款匹配查询", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/batchPriceMaintain",
    name: "batchPriceMaintain",
    component: () => import("../views/productionData/batchPriceMaintain.vue"),
    meta: {
      title: "批次价格维护", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/suForecastReport",
    name: "suForecastReport",
    component: () => import("../views/dataQuery/purchase/suForecastReport.vue"),
    meta: {
      title: "销售财务预估报表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/basicinstrumentList",
    name: "basicinstrumentList",
    component: () => import("../views/productionData/basicinstrumentList.vue"),
    meta: {
      title: "器械基础资料列表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/nearExpireList",
    name: "nearExpireList",
    component: () => import("../views/productionData/nearExpireList.vue"),
    meta: {
      title: "近效期催销查询记录", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/hyOrderReport",
    name: "hyOrderReport",
    component: () => import("../views/salesUnit/salesOrder/hyOrderReport.vue"),
    meta: {
      title: "华源锁单查询", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/exstockListReport",
    name: "exstockListReport",
    component: () =>
      import("../views/salesUnit/salesOrder/exstockListReport.vue"),
    meta: {
      title: "华源库存查询", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/storeMastList",
    name: "storeMastList",
    component: () => import("../views/store/storeMastList/storeMastList.vue"),
    meta: {
      title: "门店信息", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/cashDeskList",
    name: "cashDeskList",
    component: () => import("../views/store/cashDeskList/cashDeskList.vue"),
    meta: {
      title: "收款台信息", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/storeOutList",
    name: "storeOutList",
    component: () => import("../views/store/storeOutList/storeOutList.vue"),
    meta: {
      title: "调拨出库列表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/storeOutAudit",
    name: "storeOutAudit",
    component: () => import("../views/store/storeOutAudit/storeOutAudit.vue"),
    meta: {
      title: "调拨出库审核", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/storeOutHistList",
    name: "storeOutHistList",
    component: () =>
      import("../views/store/storeOutHistList/storeOutHistList.vue"),
    meta: {
      title: "调拨出库历史", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/storeInList",
    name: "storeInList",
    component: () => import("../views/store/storeInList/storeInList.vue"),
    meta: {
      title: "调拨入库列表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/storeInAudit",
    name: "storeInAudit",
    component: () => import("../views/store/storeInAudit/storeInAudit.vue"),
    meta: {
      title: "调拨入库审核", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/storeInHistList",
    name: "storeInHistList",
    component: () =>
      import("../views/store/storeInHistList/storeInHistList.vue"),
    meta: {
      title: "调拨入库历史", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: '/workflowSet',
    name: 'workflowSet',
    component: () =>
      import('../views/examine/workflowSet.vue'),
    meta: {
      title: '审批流程设置', // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: '/flowInstanceApply',
    name: 'flowInstanceApply',
    component: () =>
      import('../views/examine/flowInstanceApply.vue'),
    meta: {
      title: '发起申请', // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: '/flowInstanceAidit',
    name: 'flowInstanceAidit',
    component: () =>
      import('../views/examine/flowInstanceAidit.vue'),
    meta: {
      title: '待我审批', // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: '/flowInstanceSubmit',
    name: 'flowInstanceSubmit',
    component: () =>
      import('../views/examine/flowInstanceSubmit.vue'),
    meta: {
      title: '我提交的', // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: '/flowInstanceHis',
    name: 'flowInstanceHis',
    component: () =>
      import('../views/examine/flowInstanceHis.vue'),
    meta: {
      title: '审批历史', // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: '/UDIrecord',
    name: 'UDIrecord',
    component: () =>
      import('../views/UDI/UDIrecord.vue'),
    meta: {
      title: 'UDI记录', // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/maintenanceAudit",
    name: "maintenanceAudit",
    component: () => import("../views/gspUnit/maintenanceAudit.vue"),
    meta: {
      title: "养护计划审核", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  // 报表
  {
    path: "/ccRecord",
    name: "ccRecord",
    component: () =>
      import("../views/gspUnit/allocationRecord/ccRecord.vue"),
    meta: {
      title: "出库记录", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/fhRecord",
    name: "fhRecord",
    component: () =>
      import("../views/gspUnit/allocationRecord/fhRecord.vue"),
    meta: {
      title: "复核记录", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/ckjzRecord",
    name: "ckjzRecord",
    component: () =>
      import("../views/gspUnit/allocationRecord/ckjzRecord.vue"),
    meta: {
      title: "出库记账记录", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/rkRecord",
    name: "rkRecord",
    component: () =>
      import("../views/gspUnit/allocationRecord/rkRecord.vue"),
    meta: {
      title: "入库记录", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/shRecord",
    name: "shRecord",
    component: () =>
      import("../views/gspUnit/allocationRecord/shRecord.vue"),
    meta: {
      title: "收货记录", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/ysRecord",
    name: "ysRecord",
    component: () =>
      import("../views/gspUnit/allocationRecord/ysRecord.vue"),
    meta: {
      title: "验收记录", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/rkjzRecord",
    name: "rkjzRecord",
    component: () =>
      import("../views/gspUnit/allocationRecord/rkjzRecord.vue"),
    meta: {
      title: "入库记账记录", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/zdlbAuditList",
    name: "zdlbAuditList",
    component: () => import("../views/purchasing/zdList/zdlbAuditList.vue"),
    meta: {
      title: "直调出库审核", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/recallRetrieveList",
    name: "recallRetrieveList",
    component: () =>
      import("../views/gspUnit/recallRetrieve/recallRetrieveList.vue"),
    meta: {
      title: "召回通知列表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/recallRetrieveTask",
    name: "recallRetrieveTask",
    component: () =>
      import("../views/gspUnit/recallRetrieve/recallRetrieveTask.vue"),
    meta: {
      title: "召回通知审核", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/recallRetrieveHandOut",
    name: "recallRetrieveHandOut",
    component: () =>
      import("../views/gspUnit/recallRetrieve/recallRetrieveHandOut.vue"),
    meta: {
      title: "召回通知分发", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/recallRetrieveCheck",
    name: "recallRetrieveCheck",
    component: () =>
      import("../views/gspUnit/recallRetrieve/recallRetrieveCheck.vue"),
    meta: {
      title: "召回登记", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/recallRetrieveReportInit",
    name: "recallRetrieveReportInit",
    component: () =>
      import("../views/gspUnit/recallRetrieve/recallRetrieveReportInit.vue"),
    meta: {
      title: "召回报表列表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/recallRetrieveReportTask",
    name: "recallRetrieveReportTask",
    component: () =>
      import("../views/gspUnit/recallRetrieve/recallRetrieveReportTask.vue"),
    meta: {
      title: "召回报表审核", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/recallRetrieveReportHis",
    name: "recallRetrieveReportHis",
    component: () =>
      import("../views/gspUnit/recallRetrieve/recallRetrieveReportHis.vue"),
    meta: {
      title: "召回报表审核历史", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/tsCheck",
    name: "tsCheck",
    component: () =>
      import("../views/gspUnit/complaintHandle/tsCheck.vue"),
    meta: {
      title: "投诉登记", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/tsCheckTask",
    name: "tsCheckTask",
    component: () =>
      import("../views/gspUnit/complaintHandle/tsCheckTask.vue"),
    meta: {
      title: "投诉登记审核", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/tsCheckHis",
    name: "tsCheckHis",
    component: () =>
      import("../views/gspUnit/complaintHandle/tsCheckHis.vue"),
    meta: {
      title: "投诉登记历史", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/nbHandle",
    name: "nbHandle",
    component: () =>
      import("../views/gspUnit/complaintHandle/nbHandle.vue"),
    meta: {
      title: "内部处理", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/nbHandleTask",
    name: "nbHandleTask",
    component: () =>
      import("../views/gspUnit/complaintHandle/nbHandleTask.vue"),
    meta: {
      title: "内部处理审核", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/nbHandleHis",
    name: "nbHandleHis",
    component: () =>
      import("../views/gspUnit/complaintHandle/nbHandleHis.vue"),
    meta: {
      title: "内部处理历史", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/fxReport",
    name: "fxReport",
    component: () =>
      import("../views/gspUnit/complaintHandle/fxReport.vue"),
    meta: {
      title: "分析报告", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/recallRetrieveHis",
    name: "recallRetrieveHis",
    component: () =>
      import("../views/gspUnit/recallRetrieve/recallRetrieveHis.vue"),
    meta: {
      title: "召回通知历史", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/recoverRetrieveList",
    name: "recoverRetrieveList",
    component: () =>
      import("../views/gspUnit/recoverRetrieve/recoverRetrieveList.vue"),
    meta: {
      title: "追回通知列表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/recoverRetrieveTask",
    name: "recoverRetrieveTask",
    component: () =>
      import("../views/gspUnit/recoverRetrieve/recoverRetrieveTask.vue"),
    meta: {
      title: "追回通知审核", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/recoverRetrieveHis",
    name: "recoverRetrieveHis",
    component: () =>
      import("../views/gspUnit/recoverRetrieve/recoverRetrieveHis.vue"),
    meta: {
      title: "追回通知历史", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/recoverRetrieveHandOut",
    name: "recoverRetrieveHandOut",
    component: () =>
      import("../views/gspUnit/recoverRetrieve/recoverRetrieveHandOut.vue"),
    meta: {
      title: "追回分发", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/recoverRetrieveCheck",
    name: "recoverRetrieveCheck",
    component: () =>
      import("../views/gspUnit/recoverRetrieve/recoverRetrieveCheck.vue"),
    meta: {
      title: "追回登记", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/recoverRetrieveReportInit",
    name: "recoverRetrieveReportInit",
    component: () =>
      import("../views/gspUnit/recoverRetrieve/recoverRetrieveReportInit.vue"),
    meta: {
      title: "追回报告列表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/recoverRetrieveReportTask",
    name: "recoverRetrieveReportTask",
    component: () =>
      import("../views/gspUnit/recoverRetrieve/recoverRetrieveReportTask.vue"),
    meta: {
      title: "追回报告审核", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/recoverRetrieveReportHis",
    name: "recoverRetrieveReportHis",
    component: () =>
      import("../views/gspUnit/recoverRetrieve/recoverRetrieveReportHis.vue"),
    meta: {
      title: "追回报告历史", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/departmentFileManagement",
    name: "departmentFileManagement",
    component: () =>
      import("../views/organizationalStructure/departmentFileManagement.vue"),
    meta: {
      title: "部门文件管理", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/gybhgAuditList",
    name: "gybhgAuditList",
    component: () =>
      import("../views/drug/gybhgAuditList.vue"),
    meta: {
      title: "国药不合格确认", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/gyycshAuditList",
    name: "gyycshAuditList",
    component: () =>
      import("../views/drug/gyycshAuditList.vue"),
    meta: {
      title: "国药异常收货", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/priceListAdmin",
    name: "priceListAdmin",
    component: () =>
      import("../views/drug/priceListAdmin.vue"),
    meta: {
      title: "维护销售价格表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/suPriceList",
    name: "suPriceList",
    component: () =>
      import("../views/drug/suPriceList.vue"),
    meta: {
      title: "销售价目表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/priceListAdminAudit",
    name: "priceListAdminAudit",
    component: () =>
      import("../views/drug/priceListAdminAudit.vue"),
    meta: {
      title: "销售价目审批", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/priceListAdminHis",
    name: "priceListAdminHis",
    component: () =>
      import("../views/drug/priceListAdminHis.vue"),
    meta: {
      title: "销售价目历史", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/pricePuListAdmin",
    name: "pricePuListAdmin",
    component: () =>
      import("../views/drug/pricePuListAdmin.vue"),
    meta: {
      title: "维护采购价格表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  //-----------------------------寄售订单
  {
    path: "/consignmentList",
    name: "consignmentList",
    component: () =>
      import("../views/salesUnit/consignment/consignmentList.vue"),
    meta: {
      title: "寄售订单列表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/consignmentReturn",
    name: "consignmentReturn",
    component: () =>
      import("../views/salesUnit/consignment/consignmentReturn.vue"),
    meta: {
      title: "寄售回库列表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/consignmentReportList",
    name: "consignmentReportList",
    component: () =>
      import("../views/salesUnit/consignment/consignmentReportList.vue"),
    meta: {
      title: "寄售订单报表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/consignmenStockList",
    name: "consignmenStockList",
    component: () =>
      import("../views/salesUnit/consignment/consignmenStockList.vue"),
    meta: {
      title: "寄售库存查询", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/consignmentOutReportList",
    name: "consignmentOutReportList",
    component: () =>
      import("../views/salesUnit/consignment/consignmentOutReportList.vue"),
    meta: {
      title: "寄售出库订单报表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/consignmentReturnReportList",
    name: "consignmentReturnReportList",
    component: () =>
      import("../views/salesUnit/consignment/consignmentReturnReportList.vue"),
    meta: {
      title: "寄售回库订单报表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/consignmentAudit",
    name: "consignmentAudit",
    component: () =>
      import("../views/salesUnit/consignment/consignmentAudit.vue"),
    meta: {
      title: "寄售订单审核", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/consignmentHis",
    name: "consignmentHis",
    component: () =>
      import("../views/salesUnit/consignment/consignmentHis.vue"),
    meta: {
      title: "寄售订单历史", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/consignmentOutList",
    name: "consignmentOutList",
    component: () =>
      import("../views/salesUnit/consignment/consignmentOutList.vue"),
    meta: {
      title: "寄售出库列表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/consignmentOutAudit",
    name: "consignmentOutAudit",
    component: () =>
      import("../views/salesUnit/consignment/consignmentOutAudit.vue"),
    meta: {
      title: "寄售出库审核", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/consignmentOutHis",
    name: "consignmentOutHis",
    component: () =>
      import("../views/salesUnit/consignment/consignmentOutHis.vue"),
    meta: {
      title: "寄售出库历史", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/consignmentReconciliation",
    name: "consignmentReconciliation",
    component: () =>
      import("../views/salesUnit/consignment/consignmentReconciliation.vue"),
    meta: {
      title: "寄售对账单", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/consignmentReconciliationsAudit",
    name: "consignmentReconciliationsAudit",
    component: () =>
      import("../views/salesUnit/consignment/consignmentReconciliationsAudit.vue"),
    meta: {
      title: "寄售对账审核", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/consignmentReconciliationHis",
    name: "consignmentReconciliationHis",
    component: () =>
      import("../views/salesUnit/consignment/consignmentReconciliationHis.vue"),
    meta: {
      title: "寄售对账历史", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  //-----------------------------------------------------------------------------------------------------------------------
  //  ---------------------------------------------------------------------------------------------------------------------
  {
    path: "/stockpurchaseBack",
    name: "stockpurchaseBack",
    component: () =>
      import("../views/purchasing/purchaseReturn/stockpurchaseBack.vue"),
    meta: {
      title: "库存采退一步", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/hospitalList",
    name: "hospitalList",
    component: () => import("../views/otherData/hospitalList.vue"),
    meta: {
      title: "医院信息管理", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/baseproline",
    name: "baseproline",
    component: () => import("../views/otherData/baseproline.vue"),
    meta: {
      title: "产品线", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/baseregistnoList",
    name: "baseregistnoList",
    component: () => import("../views/otherData/baseregistnoList.vue"),
    meta: {
      title: "注册证资料", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/basemanufacturerList",
    name: "basemanufacturerList",
    component: () => import("../views/otherData/basemanufacturerList.vue"),
    meta: {
      title: "生产厂商资料", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/basebrandList",
    name: "basebrandList",
    component: () => import("../views/otherData/basebrandList.vue"),
    meta: {
      title: "品牌资料", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/consumeConfirm",
    name: "consumeConfirm",
    component: () => import("../views/salesUnit/salesOrder/consumeConfirm.vue"),
    meta: {
      title: "消耗单确认列表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/consumeCheckList",
    name: "consumeCheckList",
    component: () => import("../views/salesUnit/salesOrder/consumeCheckList.vue"),
    meta: {
      title: "消耗复核记录", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/consumeYsList",
    name: "consumeYsList",
    component: () => import("../views/salesUnit/salesOrder/consumeYsList.vue"),
    meta: {
      title: "回库验收记录", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/toolBill",
    name: "toolBill",
    component: () => import("../views/customization/toolBill.vue"),
    meta: {
      title: "工具计费规则", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  //业务员提成
  {
    path: "/salesCommissionList",
    name: "salesCommissionList",
    component: () => import("../views/salesUnit/salesCommission/salesCommissionList.vue"),
    meta: {
      title: "提成修改列表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/salesCommissionTask",
    name: "salesCommissionTask",
    component: () => import("../views/salesUnit/salesCommission/salesCommissionTask.vue"),
    meta: {
      title: "提成修改审核", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/salesCommissionHistory",
    name: "salesCommissionHistory",
    component: () => import("../views/salesUnit/salesCommission/salesCommissionHistory.vue"),
    meta: {
      title: "提成修改历史", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/salesCommissionScheme",
    name: "salesCommissionScheme",
    component: () => import("../views/salesUnit/salesCommission/salesCommissionScheme.vue"),
    meta: {
      title: "提成方案查询", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/salesCommissionRecord",
    name: "salesCommissionRecord",
    component: () => import("../views/salesUnit/salesCommission/salesCommissionRecord.vue"),
    meta: {
      title: "业务员提成查询", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/classify",
    name: "classify",
    component: () => import("../views/optionSettings/customHomePage/classify/classify.vue"),
    meta: {
      title: "分类", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/slideshow",
    name: "slideshow",
    component: () => import("../views/optionSettings/customHomePage/slideshow/slideshow.vue"),
    meta: {
      title: "轮播图", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/creditApplyList",
    name: "creditApplyList",
    component: () => import("../views/salesUnit/creditApply/creditApplyList.vue"),
    meta: {
      title: "销售授信申请列表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/creditApplyHis",
    name: "creditApplyHis",
    component: () => import("../views/salesUnit/creditApply/creditApplyHis.vue"),
    meta: {
      title: "销售授信申请历史", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/creditApplyAudit",
    name: "creditApplyAudit",
    component: () => import("../views/salesUnit/creditApply/creditApplyAudit.vue"),
    meta: {
      title: "销售授信申请审核", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/creditResultList",
    name: "creditResultList",
    component: () => import("../views/salesUnit/creditApply/creditResultList.vue"),
    meta: {
      title: "销售信贷列表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/creditApplyReport",
    name: "creditApplyReport",
    component: () => import("../views/salesUnit/creditApply/creditApplyReport.vue"),
    meta: {
      title: "超销售信贷报表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/rebateAgreementList",
    name: "rebateAgreementList",
    component: () => import("../views/purchasing/rebateAgreement/rebateAgreementList.vue"),
    meta: {
      title: "返利协议列表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/rebateAgreementAudit",
    name: "rebateAgreementAudit",
    component: () => import("../views/purchasing/rebateAgreement/rebateAgreementAudit.vue"),
    meta: {
      title: "返利协议审核", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/rebateAgreementHis",
    name: "rebateAgreementHis",
    component: () => import("../views/purchasing/rebateAgreement/rebateAgreementHis.vue"),
    meta: {
      title: "返利协议历史", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/rebateAgreementHis",
    name: "rebateAgreementHis",
    component: () => import("../views/purchasing/rebateAgreement/rebateAgreementHis.vue"),
    meta: {
      title: "返利协议历史", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/rebateConfirm",
    name: "rebateConfirm",
    component: () => import("../views/purchasing/rebateAgreement/rebateConfirm.vue"),
    meta: {
      title: "返利到账确认", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/rebateRecReport",
    name: "rebateRecReport",
    component: () => import("../views/purchasing/rebateAgreement/rebateRecReport.vue"),
    meta: {
      title: "返利应收报表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/rebateTotalReport",
    name: "rebateTotalReport",
    component: () => import("../views/purchasing/rebateAgreement/rebateTotalReport.vue"),
    meta: {
      title: "返利汇总查询", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/rebateRecWarn",
    name: "rebateRecWarn",
    component: () => import("../views/purchasing/rebateAgreement/rebateRecWarn.vue"),
    meta: {
      title: "返利应收预警", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  //--------------------------------------------------零售------------------------------------------------------------------
  //--------------------------------------------------零售------------------------------------------------------------------
  //--------------------------------------------------零售------------------------------------------------------------------
  //--------------------------------------------------零售------------------------------------------------------------------
  //--------------------------------------------------零售------------------------------------------------------------------
  //--------------------------------------------------零售------------------------------------------------------------------
  //--------------------------------------------------零售------------------------------------------------------------------
  //--------------------------------------------------零售------------------------------------------------------------------
  //--------------------------------------------------零售--------------------------------------------------------------
  {
    path: "/membermastList",
    name: "membermastList",
    component: () => import("../views/store/membermastList/membermastList.vue"),
    meta: {
      title: "会员卡", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/memberPointRecordList",
    name: "memberPointRecordList",
    component: () => import("../views/store/membermastList/memberPointRecordList.vue"),
    meta: {
      title: "会员积分流水", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/memberStoredRecordList",
    name: "memberStoredRecordList",
    component: () => import("../views/store/membermastList/memberStoredRecordList.vue"),
    meta: {
      title: "会员余额流水", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/retailCostAdjustmentUpdata",
    name: "retailCostAdjustmentUpdata",
    component: () => import("../views/customization/retailCostAdjustmentUpdata.vue"),
    meta: {
      title: "零售调整成本", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/memCardType",
    name: "memCardType",
    component: () => import("../views/store/memCardType/memCardType.vue"),
    meta: {
      title: "会员卡类型", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/priceGroup",
    name: "priceGroup",
    component: () => import("../views/store/priceGroup/priceGroup.vue"),
    meta: {
      title: "价格组", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/cashier",
    name: "cashier",
    component: () => import("../views/store/cashier/cashier.vue"),
    meta: {
      title: "收款台", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/shopSplit",
    name: "shopSplit",
    component: () => import("../views/store/shopSplit/shopSplit.vue"),
    meta: {
      title: "商品拆分", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/shopSplitAudit",
    name: "shopSplitAudit",
    component: () => import("../views/store/shopSplitAudit/shopSplitAudit.vue"),
    meta: {
      title: "商品拆分审核", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/shopSplitHistList",
    name: "shopSplitHistList",
    component: () =>
      import("../views/store/shopSplitHistList/shopSplitHistList.vue"),
    meta: {
      title: "商品拆分历史", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },

  {
    path: "/cashRecord",
    name: "cashRecord",
    component: () => import("../views/store/cashRecord/cashRecord.vue"),
    meta: {
      title: "收款记录", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/cxList",
    name: "cxList",
    component: () => import("../views/store/cxList/cxList.vue"),
    meta: {
      title: "促销列表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/cxAudit",
    name: "cxAudit",
    component: () => import("../views/store/cxAudit/cxAudit.vue"),
    meta: {
      title: "促销审核", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/cxHistList",
    name: "cxHistList",
    component: () => import("../views/store/cxHistList/cxHistList.vue"),
    meta: {
      title: "促销历史", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/goodsCategory",
    name: "goodsCategory",
    component: () => import("../views/store/goodsCategory/goodsCategory.vue"),
    meta: {
      title: "商品分类", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/couponList",
    name: "couponList",
    component: () => import("../views/store/couponList/couponList.vue"),
    meta: {
      title: "优惠券列表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/couponAudit",
    name: "couponAudit",
    component: () => import("../views/store/couponAudit/couponAudit.vue"),
    meta: {
      title: "优惠券审核", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },

  {
    path: "/couponHistList",
    name: "couponHistList",
    component: () => import("../views/store/couponHistList/couponHistList.vue"),
    meta: {
      title: "优惠券历史", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/storeOutQueryRc",
    name: "storeOutQueryRc",
    component: () => import("../views/store/storeOutQueryRc/storeOutQueryRc.vue"),
    meta: {
      title: "调拨出库复核", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/storeOutQueryJz",
    name: "storeOutQueryJz",
    component: () => import("../views/store/storeOutQueryJz/storeOutQueryJz.vue"),
    meta: {
      title: "调拨出库记账", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/storeOutQueryHis",
    name: "storeOutQueryHis",
    component: () => import("../views/store/storeOutQueryHis/storeOutQueryHis.vue"),
    meta: {
      title: "调拨出库历史", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/storeInQueryCa",
    name: "storeInQueryCa",
    component: () => import("../views/store/storeInQueryCa/storeInQueryCa.vue"),
    meta: {
      title: "调拨入库收货", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/storeInSubmitTo",
    name: "storeInSubmitTo",
    component: () => import("../views/store/storeInSubmitTo/storeInSubmitTo.vue"),
    meta: {
      title: "调拨入库验收", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/storeInQueryBke",
    name: "storeInQueryBke",
    component: () => import("../views/store/storeInQueryBke/storeInQueryBke.vue"),
    meta: {
      title: "调拨入库记账", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/storeInQueryBkeHis",
    name: "storeInQueryBkeHis",
    component: () => import("../views/store/storeInQueryBkeHis/storeInQueryBkeHis.vue"),
    meta: {
      title: "调拨入库记账历史", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/qhList",
    name: "qhList",
    component: () => import("../views/store/qhList/qhList.vue"),
    meta: {
      title: "请货列表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/qhAudit",
    name: "qhAudit",
    component: () => import("../views/store/qhAudit/qhAudit.vue"),
    meta: {
      title: "请货审核", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/qhHistList",
    name: "qhHistList",
    component: () => import("../views/store/qhHistList/qhHistList.vue"),
    meta: {
      title: "请货历史", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/psOutList",
    name: "psOutList",
    component: () => import("../views/store/psOutList/psOutList.vue"),
    meta: {
      title: "配送出库列表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/psOutAudit",
    name: "psOutAudit",
    component: () => import("../views/store/psOutAudit/psOutAudit.vue"),
    meta: {
      title: "配送出库审核", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/psOutHisList",
    name: "psOutHisList",
    component: () => import("../views/store/psOutHisList/psOutHisList.vue"),
    meta: {
      title: "配送出库历史", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/psOutQueryRc",
    name: "psOutQueryRc",
    component: () => import("../views/store/psOutQueryRc/psOutQueryRc.vue"),
    meta: {
      title: "配送出库复核", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/psOutQueryJz",
    name: "psOutQueryJz",
    component: () => import("../views/store/psOutQueryJz/psOutQueryJz.vue"),
    meta: {
      title: "配送出库记账", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/psOutQueryHis",
    name: "psOutQueryHis",
    component: () => import("../views/store/psOutQueryHis/psOutQueryHis.vue"),
    meta: {
      title: "配送出库记账历史", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/mdInList",
    name: "mdInList",
    component: () => import("../views/store/mdInList/mdInList.vue"),
    meta: {
      title: "门店入库列表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/mdInAudit",
    name: "mdInAudit",
    component: () => import("../views/store/mdInAudit/mdInAudit.vue"),
    meta: {
      title: "门店入库审核", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/mdInHistList",
    name: "mdInHistList",
    component: () => import("../views/store/mdInHistList/mdInHistList.vue"),
    meta: {
      title: "门店入库历史", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/mdInQueryCa",
    name: "mdInQueryCa",
    component: () => import("../views/store/mdInQueryCa/mdInQueryCa.vue"),
    meta: {
      title: "门店入库收货", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/mdInSubmitTo",
    name: "mdInSubmitTo",
    component: () => import("../views/store/mdInSubmitTo/mdInSubmitTo.vue"),
    meta: {
      title: "门店入库验收", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/mdInQueryBke",
    name: "mdInQueryBke",
    component: () => import("../views/store/mdInQueryBke/mdInQueryBke.vue"),
    meta: {
      title: "门店入库记账", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/mdInQueryBkeHis",
    name: "mdInQueryBkeHis",
    component: () => import("../views/store/mdInQueryBkeHis/mdInQueryBkeHis.vue"),
    meta: {
      title: "门店入库记账历史", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/mdBackList",
    name: "mdBackList",
    component: () => import("../views/store/mdBackList/mdBackList.vue"),
    meta: {
      title: "门店退货列表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/mdBackAudit",
    name: "mdBackAudit",
    component: () => import("../views/store/mdBackAudit/mdBackAudit.vue"),
    meta: {
      title: "门店退货审核", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/mdBackHistList",
    name: "mdBackHistList",
    component: () => import("../views/store/mdBackHistList/mdBackHistList.vue"),
    meta: {
      title: "门店退货历史", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/mdBackQueryRc",
    name: "mdBackQueryRc",
    component: () => import("../views/store/mdBackQueryRc/mdBackQueryRc.vue"),
    meta: {
      title: "门店退货复核", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/mdBackQueryJz",
    name: "mdBackQueryJz",
    component: () => import("../views/store/mdBackQueryJz/mdBackQueryJz.vue"),
    meta: {
      title: "门店退货记账", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/mdBackQueryHis",
    name: "mdBackQueryHis",
    component: () => import("../views/store/mdBackQueryHis/mdBackQueryHis.vue"),
    meta: {
      title: "门店退货记账历史", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/mdBackQuerySh",
    name: "mdBackQuerySh",
    component: () => import("../views/store/mdBackQuerySh/mdBackQuerySh.vue"),
    meta: {
      title: "退货收货列表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/mdBackQueryShAudit",
    name: "mdBackQueryShAudit",
    component: () => import("../views/store/mdBackQueryShAudit/mdBackQueryShAudit.vue"),
    meta: {
      title: "退货收货审核", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/mdBackQueryShHis",
    name: "mdBackQueryShHis",
    component: () => import("../views/store/mdBackQueryShHis/mdBackQueryShHis.vue"),
    meta: {
      title: "退货收货历史", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/mdBackQueryShSh",
    name: "mdBackQueryShSh",
    component: () => import("../views/store/mdBackQueryShSh/mdBackQueryShSh.vue"),
    meta: {
      title: "退货收货收货", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/mdBackQueryShSubmitTo",
    name: "mdBackQueryShSubmitTo",
    component: () => import("../views/store/mdBackQueryShSubmitTo/mdBackQueryShSubmitTo.vue"),
    meta: {
      title: "退货收货验收", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/mdBackQueryShJz",
    name: "mdBackQueryShJz",
    component: () => import("../views/store/mdBackQueryShJz/mdBackQueryShJz.vue"),
    meta: {
      title: "退货收货记账", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/mdBackQueryShJsRk",
    name: "mdBackQueryShJsRk",
    component: () => import("../views/store/mdBackQueryShJsRk/mdBackQueryShJsRk.vue"),
    meta: {
      title: "退货入库拒收入库", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/mdBackQueryShJzHis",
    name: "mdBackQueryShJzHis",
    component: () => import("../views/store/mdBackQueryShJzHis/mdBackQueryShJzHis.vue"),
    meta: {
      title: "退货收货记账历史", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/fdInventory",
    name: "fdInventory",
    component: () => import("../views/store/ReportAnalyzeList/fdInventory.vue"),
    meta: {
      title: "分店库存查询", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/fdInventory2",
    name: "fdInventory2",
    component: () => import("../views/store/ReportAnalyzeList/fdInventory2.vue"),
    meta: {
      title: "分店库存查询2", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/fdInventory3",
    name: "fdInventory3",
    component: () => import("../views/store/ReportAnalyzeList/fdInventory3.vue"),
    meta: {
      title: "分店库存查询3", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/fdInventory4",
    name: "fdInventory4",
    component: () => import("../views/store/ReportAnalyzeList/fdInventory4.vue"),
    meta: {
      title: "当日销售记录查询", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/fdInventory5",
    name: "fdInventory5",
    component: () => import("../views/store/ReportAnalyzeList/fdInventory5.vue"),
    meta: {
      title: "当日销售记录查询", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/fdInventory6",
    name: "fdInventory6",
    component: () => import("../views/store/ReportAnalyzeList/fdInventory6.vue"),
    meta: {
      title: "当日销售记录查询", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/fdInventory7",
    name: "fdInventory7",
    component: () => import("../views/store/ReportAnalyzeList/fdInventory7.vue"),
    meta: {
      title: "当日销售记录查询", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/fdInventory8",
    name: "fdInventory8",
    component: () => import("../views/store/ReportAnalyzeList/fdInventory8.vue"),
    meta: {
      title: "当日销售记录查询", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/fdInventory9",
    name: "fdInventory9",
    component: () => import("../views/store/ReportAnalyzeList/fdInventory9.vue"),
    meta: {
      title: "当日销售记录查询", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/fdInventory10",
    name: "fdInventory10",
    component: () => import("../views/store/ReportAnalyzeList/fdInventory10.vue"),
    meta: {
      title: "当日销售记录查询", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/fdInventory11",
    name: "fdInventory11",
    component: () => import("../views/store/ReportAnalyzeList/fdInventory11.vue"),
    meta: {
      title: "当日销售记录查询", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/fdInventory12",
    name: "fdInventory12",
    component: () => import("../views/store/ReportAnalyzeList/fdInventory12.vue"),
    meta: {
      title: "当日销售记录查询", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/fdInventory13",
    name: "fdInventory13",
    component: () => import("../views/store/ReportAnalyzeList/fdInventory13.vue"),
    meta: {
      title: "当日销售记录查询", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/fdInventory14",
    name: "fdInventory14",
    component: () => import("../views/store/ReportAnalyzeList/fdInventory14.vue"),
    meta: {
      title: "当日销售记录查询", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/fdInventory15",
    name: "fdInventory15",
    component: () => import("../views/store/ReportAnalyzeList/fdInventory15.vue"),
    meta: {
      title: "当日销售记录查询", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/fdInventory16",
    name: "fdInventory16",
    component: () => import("../views/store/ReportAnalyzeList/fdInventory16.vue"),
    meta: {
      title: "当日销售记录查询", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/fdInventory17",
    name: "fdInventory17",
    component: () => import("../views/store/ReportAnalyzeList/fdInventory17.vue"),
    meta: {
      title: "当日销售记录查询", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/fdInventory18",
    name: "fdInventory18",
    component: () => import("../views/store/ReportAnalyzeList/fdInventory18.vue"),
    meta: {
      title: "当日销售记录查询", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/fdInventory19",
    name: "fdInventory19",
    component: () => import("../views/store/ReportAnalyzeList/fdInventory19.vue"),
    meta: {
      title: "当日销售记录查询", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/fdInventory20",
    name: "fdInventory20",
    component: () => import("../views/store/ReportAnalyzeList/fdInventory20.vue"),
    meta: {
      title: "当日销售记录查询", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/fdInventory21",
    name: "fdInventory21",
    component: () => import("../views/store/ReportAnalyzeList/fdInventory21.vue"),
    meta: {
      title: "当日销售记录查询", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/fdInventory22",
    name: "fdInventory22",
    component: () => import("../views/store/ReportAnalyzeList/fdInventory22.vue"),
    meta: {
      title: "当日销售记录查询", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/fdInventory23",
    name: "fdInventory23",
    component: () => import("../views/store/ReportAnalyzeList/fdInventory23.vue"),
    meta: {
      title: "当日销售记录查询", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/fdInventory24",
    name: "fdInventory24",
    component: () => import("../views/store/ReportAnalyzeList/fdInventory24.vue"),
    meta: {
      title: "当日销售记录查询", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/fdInventory25",
    name: "fdInventory25",
    component: () => import("../views/store/ReportAnalyzeList/fdInventory25.vue"),
    meta: {
      title: "当日销售记录查询", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/fdInventory26",
    name: "fdInventory26",
    component: () => import("../views/store/ReportAnalyzeList/fdInventory26.vue"),
    meta: {
      title: "当日销售记录查询", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/fdInventory27",
    name: "fdInventory27",
    component: () => import("../views/store/ReportAnalyzeList/fdInventory27.vue"),
    meta: {
      title: "当日销售记录查询", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/fdInventory28",
    name: "fdInventory28",
    component: () => import("../views/store/ReportAnalyzeList/fdInventory28.vue"),
    meta: {
      title: "当日销售记录查询", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/fdInventory29",
    name: "fdInventory29",
    component: () => import("../views/store/ReportAnalyzeList/fdInventory29.vue"),
    meta: {
      title: "当日销售记录查询", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/fdInventory30",
    name: "fdInventory30",
    component: () => import("../views/store/ReportAnalyzeList/fdInventory30.vue"),
    meta: {
      title: "当日销售记录查询", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/fdInventory31",
    name: "fdInventory31",
    component: () => import("../views/store/ReportAnalyzeList/fdInventory31.vue"),
    meta: {
      title: "当日销售记录查询", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/fdInventory32",
    name: "fdInventory32",
    component: () => import("../views/store/ReportAnalyzeList/fdInventory32.vue"),
    meta: {
      title: "当日销售记录查询", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/fdInventory33",
    name: "fdInventory33",
    component: () => import("../views/store/ReportAnalyzeList/fdInventory33.vue"),
    meta: {
      title: "当日销售记录查询", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/fdInventory34",
    name: "fdInventory34",
    component: () => import("../views/store/ReportAnalyzeList/fdInventory34.vue"),
    meta: {
      title: "当日销售记录查询", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/fdInventory35",
    name: "fdInventory35",
    component: () => import("../views/store/ReportAnalyzeList/fdInventory35.vue"),
    meta: {
      title: "当日销售记录查询", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/fdInventory36",
    name: "fdInventory36",
    component: () => import("../views/store/ReportAnalyzeList/fdInventory36.vue"),
    meta: {
      title: "当日销售记录查询", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/fdInventory37",
    name: "fdInventory37",
    component: () => import("../views/store/ReportAnalyzeList/fdInventory37.vue"),
    meta: {
      title: "当日销售记录查询", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/fdInventory38",
    name: "fdInventory38",
    component: () => import("../views/store/ReportAnalyzeList/fdInventory38.vue"),
    meta: {
      title: "当日销售记录查询", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/fdInventory39",
    name: "fdInventory39",
    component: () => import("../views/store/ReportAnalyzeList/fdInventory39.vue"),
    meta: {
      title: "当日销售记录查询", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/fdInventory40",
    name: "fdInventory40",
    component: () => import("../views/store/ReportAnalyzeList/fdInventory40.vue"),
    meta: {
      title: "当日销售记录查询", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/fdInventory41",
    name: "fdInventory41",
    component: () => import("../views/store/ReportAnalyzeList/fdInventory41.vue"),
    meta: {
      title: "当日销售记录查询", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/fdInventory42",
    name: "fdInventory42",
    component: () => import("../views/store/ReportAnalyzeList/fdInventory42.vue"),
    meta: {
      title: "当日销售记录查询", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/fdInventory43",
    name: "fdInventory43",
    component: () => import("../views/store/ReportAnalyzeList/fdInventory43.vue"),
    meta: {
      title: "当日销售记录查询", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/fdInventory44",
    name: "fdInventory44",
    component: () => import("../views/store/ReportAnalyzeList/fdInventory44.vue"),
    meta: {
      title: "当日销售记录查询", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/fdInventory45",
    name: "fdInventory45",
    component: () => import("../views/store/ReportAnalyzeList/fdInventory45.vue"),
    meta: {
      title: "当日销售记录查询", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/fdInventory46",
    name: "fdInventory46",
    component: () => import("../views/store/ReportAnalyzeList/fdInventory46.vue"),
    meta: {
      title: "当日销售记录查询", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/fdInventory47",
    name: "fdInventory47",
    component: () => import("../views/store/ReportAnalyzeList/fdInventory47.vue"),
    meta: {
      title: "当日销售记录查询", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/fdInventory48",
    name: "fdInventory48",
    component: () => import("../views/store/ReportAnalyzeList/fdInventory48.vue"),
    meta: {
      title: "当日销售记录查询", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/fdInventory49",
    name: "fdInventory49",
    component: () => import("../views/store/ReportAnalyzeList/fdInventory49.vue"),
    meta: {
      title: "当日销售记录查询", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/fdInventory50",
    name: "fdInventory50",
    component: () => import("../views/store/ReportAnalyzeList/fdInventory50.vue"),
    meta: {
      title: "当日销售记录查询", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/fdInventory51",
    name: "fdInventory51",
    component: () => import("../views/store/ReportAnalyzeList/fdInventory51.vue"),
    meta: {
      title: "当日销售记录查询", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/fdInventory52",
    name: "fdInventory52",
    component: () => import("../views/store/ReportAnalyzeList/fdInventory52.vue"),
    meta: {
      title: "当日销售记录查询", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/fdInventory53",
    name: "fdInventory53",
    component: () => import("../views/store/ReportAnalyzeList/fdInventory53.vue"),
    meta: {
      title: "当日销售记录查询", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/fdInventory54",
    name: "fdInventory54",
    component: () => import("../views/store/ReportAnalyzeList/fdInventory54.vue"),
    meta: {
      title: "当日销售记录查询", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/fdInventory55",
    name: "fdInventory55",
    component: () => import("../views/store/ReportAnalyzeList/fdInventory55.vue"),
    meta: {
      title: "当日销售记录查询", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/headquartersInventoryFlow",
    name: "headquartersInventoryFlow",
    component: () => import("../views/store/ReportAnalyzeList/headquartersInventoryFlow.vue"),
    meta: {
      title: "总部库存流水", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/drugReport",
    name: "drugReport",
    component: () => import("../views/drug/drugReport.vue"),
    meta: {
      title: "药品不良反应/事件报告表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/drugInformation",
    name: "drugInformation",
    component: () => import("../views/drug/drugInformation.vue"),
    meta: {
      title: "药品群体不良事件基本信息表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/zdList",
    name: "zdList",
    component: () => import("../views/store/zdList/zdList.vue"),
    meta: {
      title: "装斗列表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/zdHistList",
    name: "zdHistList",
    component: () => import("../views/store/zdHistList/zdHistList.vue"),
    meta: {
      title: "装斗历史列表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/jqPrint",
    name: "jqPrint",
    component: () => import("../views/store/jqPrint/jqPrint.vue"),
    meta: {
      title: "价签打印", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/zdFhList",
    name: "zdFhList",
    component: () => import("../views/store/zdFhList/zdFhList.vue"),
    meta: {
      title: "装斗复核", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/zdQdList",
    name: "zdQdList",
    component: () => import("../views/store/zdQdList/zdQdList.vue"),
    meta: {
      title: "装斗", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/cashierHj",
    name: "cashierHj",
    component: () => import("../views/store/cashierHj/cashierHj.vue"),
    meta: {
      title: "划价台", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/psOutprint",
    name: "psOutprint",
    component: () => import("../views/store/psOutprint/psOutprint.vue"),
    meta: {
      title: "配送出库批量打印", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/mdOutList",
    name: "mdOutList",
    component: () => import("../views/store/mdOutList/mdOutList.vue"),
    meta: {
      title: "门店调拨列表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/mdOutListHis",
    name: "mdOutListHis",
    component: () => import("../views/store/mdOutListHis/mdOutListHis.vue"),
    meta: {
      title: "门店调拨历史列表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/hjManagement",
    name: "hjManagement",
    component: () => import("../views/store/hjManagement/hjManagement.vue"),
    meta: {
      title: "货架管理", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/webPayRejList",
    name: "webPayRejList",
    component: () => import("../views/store/webPayRejList/webPayRejList.vue"),
    meta: {
      title: "线上支付退款查询", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/ypcxList",
    name: "ypcxList",
    component: () => import("../views/store/ypcxList/ypcxList.vue"),
    meta: {
      title: "药品陈列", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/ypcxListConfig",
    name: "ypcxListConfig",
    component: () => import("../views/store/ypcxList/ypcxListConfig.vue"),
    meta: {
      title: "药品陈列配置", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/singleShopSplit",
    name: "singleShopSplit",
    component: () => import("../views/store/singleShopSplit/singleShopSplit.vue"),
    meta: {
      title: "单商品拆分", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/singleShopSplitAudit",
    name: "singleShopSplitAudit",
    component: () => import("../views/store/singleShopSplitAudit/singleShopSplitAudit.vue"),
    meta: {
      title: "单商品拆分审核", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/singleShopSplitHistList",
    name: "singleShopSplitHistList",
    component: () => import("../views/store/singleShopSplitHistList/singleShopSplitHistList.vue"),
    meta: {
      title: "单商品拆分历史", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/grossRule",
    name: "grossRule",
    component: () => import("../views/store/grossRule/grossRule.vue"),
    meta: {
      title: "提成等级", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/jfMaintenance",
    name: "jfMaintenance",
    component: () => import("../views/store/jfMaintenance/jfMaintenance.vue"),
    meta: {
      title: "兑换积分维护", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/otherRk",
    name: "otherRk",
    component: () => import("../views/purchasing/purchaseOrder/otherRk.vue"),
    meta: {
      title: "其他入库", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/otherRkHis",
    name: "otherRkHis",
    component: () => import("../views/purchasing/purchaseOrder/otherRkHis.vue"),
    meta: {
      title: "其他入库历史", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/recependAudit",
    name: "recependAudit",
    component: () => import("../views/purchasing/purchaseOrder/recependAudit.vue"),
    meta: {
      title: "异常收货审批", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/recependHis",
    name: "recependHis",
    component: () => import("../views/purchasing/purchaseOrder/recependHis.vue"),
    meta: {
      title: "异常收货历史 ", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/licenseexpiAudit",
    name: "licenseexpiAudit",
    component: () => import("../views/purchasing/purchaseOrder/licenseexpiAudit.vue"),
    meta: {
      title: "临时证照审批", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/licenseexpiHis",
    name: "licenseexpiHis",
    component: () => import("../views/purchasing/purchaseOrder/licenseexpiHis.vue"),
    meta: {
      title: "临时证照历史", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/jfRedemption",
    name: "jfRedemption",
    component: () => import("../views/store/jfRedemption/jfRedemption.vue"),
    meta: {
      title: "积分兑换", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/stockFbList",
    name: "stockFbList",
    component: () => import("../views/store/stockFbList/stockFbList.vue"),
    meta: {
      title: "库存分布查询", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/editJF",
    name: "editJF",
    component: () => import("../views/store/editJF/editJF.vue"),
    meta: {
      title: "修改积分", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/getKeyQuery",
    name: "getKeyQuery",
    component: () => import("../views/store/getKeyQuery/getKeyQuery.vue"),
    meta: {
      title: "快捷键配置", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/stockCuList",
    name: "stockCuList",
    component: () => import("../views/store/stockCuList/stockCuList.vue"),
    meta: {
      title: "历史库存记录", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/ptStrategy",
    name: "ptStrategy",
    component: () => import("../views/optionSettings/ptStrategy/ptStrategy.vue"),
    meta: {
      title: "平台价格策略", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/orgBgmRelationQuery",
    name: "orgBgmRelationQuery",
    component: () => import("../views/optionSettings/orgBgmRelationQuery.vue"),
    meta: {
      title: "组织商品管理", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/wdtWaitUpMoveDetail",
    name: "wdtWaitUpMoveDetail",
    component: () => import("../views/optionSettings/wdtWaitUpMoveDetail.vue"),
    meta: {
      title: "待上架移库明细", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/wesScanMonitor",
    name: "wesScanMonitor",
    component: () => import("../views/optionSettings/wesScanMonitor.vue"),
    meta: {
      title: "扫描监控", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/wesScanTask",
    name: "wesScanTask",
    component: () => import("../views/optionSettings/wesScanTask.vue"),
    meta: {
      title: "扫描任务", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/xsorderPoolSpdList",
    name: "xsorderPoolSpdList",
    component: () => import("../views/salesUnit/salesOrder/xsorderPoolSpdList/xsorderPoolSpdList.vue"),
    meta: {
      title: "spd订单列表", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/jcOrderPoolList",
    name: "jcOrderPoolList",
    component: () => import("../views/salesUnit/salesOrder/jcOrderPoolList.vue"),
    meta: {
      title: "集采平台订单", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/storePriceManage",
    name: "storePriceManage",
    component: () => import("../views/store/storePriceManage/storePriceManage.vue"),
    meta: {
      title: "门店价格维护", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/storePriceHis",
    name: "storePriceHis",
    component: () => import("../views/store/ReportAnalyzeList/storePriceHis.vue"),
    meta: {
      title: "门店价格修改历史", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/aiCgAnalysis",
    name: "aiCgAnalysis",
    component: () => import("../views/aiAnalysis/aiCgAnalysis.vue"),
    meta: {
      title: "采购订单数据分析", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/aiXSAnalysis",
    name: "aiXSAnalysis",
    component: () => import("../views/aiAnalysis/aiXSAnalysis.vue"),
    meta: {
      title: "销售订单数据分析", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/aiCWAnalysis",
    name: "aiCWAnalysis",
    component: () => import("../views/aiAnalysis/aiCWAnalysis.vue"),
    meta: {
      title: "财务数据分析", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
  {
    path: "/aiZJLAnalysis",
    name: "aiZJLAnalysis",
    component: () => import("../views/aiAnalysis/aiZJLAnalysis.vue"),
    meta: {
      title: "总经理数据分析", // 标题
      isLogin: true, // 是否要登录
      webType: 2, // 页面归类,1一级页面，2二级页面
    },
  },
];

// {
//     path: '',
//     name: '',
//     component: () =>
//         import('../views/modular.vue'),
//     meta: {
//         title: '门店模块', // 标题
//         isLogin: true, // 是否要登录
//         webType: 2, // 页面归类,1一级页面，2二级页面
//     },
// },
//当新增一个大模块时，需要添加上面的modular路由，路径home.vue 中方法selectMenuList()中的sessionStorage.setItem("homeActionMenu", this.homeActionMenu);

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});
// 避免跳转到首页的时候报错
const VueRouterPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(to) {
  return VueRouterPush.call(this, to).catch((err) => err);
};
const vueObject = new Vue({
  store,
});

router.beforeEach((to, from, next) => {
  if (to.meta.isLogin == true && vueObject.$store.state.userInfo == false) {
    next({
      path: "/login",
    });
    return false;
  }

  // if(to.fullPath == '/'){
  // 	next({
  // 		path: '/index'
  // 	})
  // 	return false
  // }
  next();
});

export default router;
